//
const modelsJustLoaded = {
	kreonCapsule: false,
	kreonFerments: false

};

const intervals = [
	{
		start: START_FRAME,
		end: 45,
		animEnd: 25
	},
	{
		start: 100.15,
		end: 139.5,
		animEnd: 28
	},
	{
		start: 200.15,
		end: 247.2,
		animEnd: 27.5
	}
];

//Отслеживание состояния вкладки браузера
const tabVisibility = function() {
	let hidden, visibilityChange, state;

	if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
		hidden = "hidden";
		visibilityChange = "visibilitychange";
		state = "visibilityState";
	} else if (typeof document.mozHidden !== "undefined") {
		hidden = "mozHidden";
		visibilityChange = "mozvisibilitychange";
		state = "mozVisibilityState";
	} else if (typeof document.msHidden !== "undefined") {
		hidden = "msHidden";
		visibilityChange = "msvisibilitychange";
		state = "msVisibilityState";
	} else if (typeof document.webkitHidden !== "undefined") {
		hidden = "webkitHidden";
		visibilityChange = "webkitvisibilitychange";
		state = "webkitVisibilityState";
	}

	function isHidden() {
		return document[hidden] || false;
	}

	function isVisible() {
		return document[state] || false
	}

	return {
		isHidden: isHidden,
		isVisible: isVisible,
		state: state,
		hidden: hidden, // string name of the "hidden" property
		visibilityChange: visibilityChange // string name of the "visibilitychange" event
	};
};

let isFocused = true;
let isTabHidden = false;
let foodPauseFrame = {
	frame: 0, allowWrite: true
};

let globalScene;
let globalEngine;
let globalHighlight;
let animationSelected = 0;
let isWindowFocused = true;
let allowPlay = true;

const MAX_FOOD_FRAME = 85.06666564941406;

const changeNumberOfSlides = number => {
	let elements = $('.timeline-item');

	for (let i = 0; i < 8; i++) {
		if (i < number) {
			elements[i].style.display = 'block'
		} else {
			elements[i].style.display = 'none'
		}
	}
}

const showKreon = () => {
	document.querySelector(`.kreon-source`).style.display = `block`;
	document.querySelector(`.capsule-source`).style.display = `none`;
	document.querySelector(`.pill-source`).style.display = `none`;

	const PILL_NODES = [`Object001`, `Cylinder258`];

	PILL_NODES.forEach((item) => {
		globalScene.getMeshByName(item).isVisible = false;
	});

	const PILL_FERMENTS = [`Pill_Ferment_Pot3`, `Pill_Ferment_Pot2`, `Pill_Ferment_Chiken`, `Pill_Ferment_Chiken_Free`];

	PILL_FERMENTS.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	// Названия нод с ферментами
	const FERMENTS_NODES = [`Ferment_Chiken`, `Ferment_Free`, `Ferment_Pot_1`, `Ferment_Pot_2`, `Ferment_Pot_3`];

	// Убирает свечение для ферментов
	FERMENTS_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = true;
		});
	});

	const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

	KREON_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = true;
		});
	});

	const CAPSULE_NODES = [`Kapsula2`, `Mikrokapsula`];

	// Убирает свечение для капсулы
	CAPSULE_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	const CAPSULE_FERMENTS = [`Capsule_Ferment_Pot3`, `Capsule_Ferment_Pot2`, `Capsule_Ferment_Chiken`, `Capsule_Ferment_Pot1`];

	// Убирает свечение для ферментов
	CAPSULE_FERMENTS.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	if (isMobileSize) {
		changeNumberOfSlides(8);
	}

	if (!isMobileSize && document.querySelector('.kreon-capsule .step2-microsphere-icon').classList.contains('step2-microsphere-icon-show')) {
		document.querySelector('.kreon-capsule .step2-microsphere-icon').classList.remove('step2-microsphere-icon-show');
	}
};

const showPill = () => {
	// Источники сноски
	document.querySelector(`.kreon-source`).style.display = `none`;
	document.querySelector(`.capsule-source`).style.display = `none`;
	document.querySelector(`.pill-source`).style.display = `block`;

	const PILL_NODES = [`Object001`, `Cylinder258`];

	PILL_NODES.forEach((item) => {
		globalScene.getMeshByName(item).isVisible = true;
	});

	const PILL_FERMENTS = [`Pill_Ferment_Pot3`, `Pill_Ferment_Pot2`, `Pill_Ferment_Chiken`, `Pill_Ferment_Chiken_Free`];

	PILL_FERMENTS.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = true;
		});
	});

	// Названия нод с ферментами
	const FERMENTS_NODES = [`Ferment_Chiken`, `Ferment_Free`, `Ferment_Pot_1`, `Ferment_Pot_2`, `Ferment_Pot_3`];

	// Убирает свечение для ферментов
	FERMENTS_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	//Прячем капсулу при нажатии на таблетку
	const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

	KREON_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	const CAPSULE_NODES = [`Kapsula2`, `Mikrokapsula`];

	// Убирает свечение для капсулы
	CAPSULE_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	const CAPSULE_FERMENTS = [`Capsule_Ferment_Pot3`, `Capsule_Ferment_Pot2`, `Capsule_Ferment_Chiken`, `Capsule_Ferment_Pot1`];

	// Убирает свечение для ферментов
	CAPSULE_FERMENTS.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	if (isMobileSize) {
		changeNumberOfSlides(8);
	}
};

const showCapsule = () => {
	// Источники сноски
	document.querySelector(`.kreon-source`).style.display = `none`;
	document.querySelector(`.pill-source`).style.display = `none`;
	document.querySelector(`.capsule-source`).style.display = `block`;

	const PILL_NODES = [`Object001`, `Cylinder258`];

	PILL_NODES.forEach((item) => {
		globalScene.getMeshByName(item).isVisible = false;
	});

	const PILL_FERMENTS = [`Pill_Ferment_Pot3`, `Pill_Ferment_Pot2`, `Pill_Ferment_Chiken`, `Pill_Ferment_Chiken_Free`];

	PILL_FERMENTS.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	// Названия нод с ферментами
	const FERMENTS_NODES = [`Ferment_Chiken`, `Ferment_Free`, `Ferment_Pot_1`, `Ferment_Pot_2`, `Ferment_Pot_3`];

	// Убирает свечение для ферментов
	FERMENTS_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	//Прячем капсулу при нажатии на таблетку
	const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

	KREON_NODES.forEach((item) => {

		console.log(globalScene.getNodeByName(item), ' -- kreon')

		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	const CAPSULE_NODES = [`Kapsula2`, `Mikrokapsula`];

	// Убирает свечение для капсулы
	CAPSULE_NODES.forEach((item) => {

		console.log(globalScene.getNodeByName(item), ' -- capsule')

		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = true;
		});
	});

	const CAPSULE_FERMENTS = [`Capsule_Ferment_Pot3`, `Capsule_Ferment_Pot2`, `Capsule_Ferment_Chiken`, `Capsule_Ferment_Pot1`];

	// Убирает свечение для ферментов
	CAPSULE_FERMENTS.forEach((item) => {
		console.log('item ', item)

		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = true;
		});
	});

	if (isMobileSize) {
		changeNumberOfSlides(5);
	}
};

// Медиавыражения для проверки ширины экрана
const isDesktopSize = window.matchMedia('(min-width: 751px)').matches;
const isMobileSize = window.matchMedia('(min-width: 0px) and (max-width: 750px)').matches;

/**
 * @description обновляет изображения для анимации.
 */
const refreshImageAnimation = () => {
	const imageAnimation = document.querySelector('.step6-animation-image .step6-image');
	const animationImageSource = document.querySelector('.step6-animation-image source');
	const imageAnimationPath = imageAnimation.src;
	const animationImageSourcePath = animationImageSource.srcset;

	imageAnimation.src = '';
	imageAnimation.src = imageAnimationPath;
	animationImageSource.srcset = '';
	animationImageSource.srcset = animationImageSourcePath;
};

/**
 * @description очищает анимацию заполнения на мобильной версии.
 */
const clearTimeline = () => {
	const timelineItems = document.querySelectorAll('.timeline-item-active');

	timelineItems.forEach((item) => {
		item.style.width = `0%`;
	});
};

/**
 * @description создает кнопки для переключения слайдов в мобильной версии.
 * @param {String} left устанавливает значение left у кнопки.
 * @param {String} right устанавливает значение right у кнопки.
 * @returns {Element} возвращает DOM элемент с нужными параметрами.
 */
const createButton = (left = `auto`, right = `auto`) => {
	const button = document.createElement(`div`);

	button.style.width = `20%`;
	button.style.height = `100%`;
	button.style.zIndex = 100;
	button.style.position = `absolute`;
	button.style.top = 0;
	button.style.left = left;
	button.style.right = right;

	return button;
};

/**
 * @description получить фрейм таймера.
 * @return {Object}
 */
const Timer = {
	timer: null,

	play: function() {
		this.timer.play();
	},

	pause: function() {
		this.timer.pause();
	},

	getFrame: function() {
		return this.timer.animatables[0].masterFrame;
	},

	returnToFrame: function(frame) {
		return this.timer.goToFrame(frame);
	}
};

// Начальный фрейм
const START_FRAME = 0.15;

// Дельта для изменения значения свечения желудка
const HL_DELTA = 0.01;

// Значение свечения желудка
const GLOW_EFFECT = 4;

// Объявление DOM элементов страницы
const filterGradient = document.querySelector(`.filter-gradient`);
const anotherCapsuleStart = document.querySelector(`.step1-item:nth-child(3) .step1-link`);
const buttonStart = document.querySelector(`.step1-item:nth-child(2) .step1-link`);
const pillButtonStart = document.querySelector(`.step1-item:nth-child(1) .step1-link`);
const sliderContainer = document.querySelector('.kreon');
const closeButton = document.querySelector('.kreon .close');
const modelsLoader = document.querySelector('.models-loader span');
const render = document.querySelector('.render');
const repeatButtonMobile = document.querySelector('.mobile-buttons');
const startPillButtonMobile = document.querySelector('.mobile-buttons .step7-btn.pills');
const startKreonButtonMobile = document.querySelector('.mobile-buttons .step7-btn.kreon-capsule');

// Флаги старта и сброса анимации для мобильной версии
let isStartButtonPressed = false;
let isCloseButtonPressed = true;

// Флаг загрузки сцены
let isMySceneLoading = false;
let loadingProgress = 0;

// Переход для слайдера на мобильной версии
let isMobileSlider = true;
let allowTimer = true;

// Счетчик для свечения желудка
let hlCounter = 0;

// Флаг вращения объекта
let isItemsRotate = true;

// Скрытие кнопок управления позиционированием
document.querySelector('.test-buttons').style.display = 'none';

// Данные для свойств камеры desktop kreon
const cameraPropertiesDataDesktop = [
	{
		sysName: 'null',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 0,
		endFrame: 0
	},
	{
		sysName: 'ready',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: START_FRAME,
		endFrame: START_FRAME
	},
	{
		sysName: 'start',
		cameraPos: [800, 760, 1600],
		// cameraPos: [740, 690, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 0.4,
		endFrame: 0.8
	},
	{
		sysName: 'pillOpen',
		// cameraPos: [660, 730, 1700],
		// cameraPos: [340, 600, 1700],
		cameraPos: [600, 688, 1638],
		rotationPos: [0, 0, 0],
		startFrame: 1.1,
		endFrame: 2.3
	},
	// {
	// 	sysName: 'pillOpen',
	// 	cameraPos: [660, 730, 1700],
	// 	// cameraPos: [340, 600, 1700],
	// 	rotationPos: [0, 0, 0],
	// 	startFrame: 2.3,
	// 	endFrame: 9.5
	// },
	{
		sysName: 'foodFirst',
		// cameraPos: [1020, 630, 1300],
		// cameraPos: [1030, 560, 1300],
		cameraPos: [314, 588, 1700],
		// cameraPos: [320, 700, 1700],
		rotationPos: [0, 0, 0],
		startFrame: 7.3, // 8 old value
		endFrame: 9.5 // 12 old value
		// endFrame: 14.5 // 12 old value
	},
	{
		sysName: 'foodSecond',
		cameraPos: [975, 545, 1300], // raw  971 476 1060
		// cameraPos: [972, 491, 1260], // raw  971 476 1060
		// cameraPos: [972, 491, 1260], // raw  971 476 1060
		// cameraPos: [30, 630, 1400], // modeifed 972 491 1260
		rotationPos: [0, 0, 0],
		startFrame: 10, // 17 old value
		endFrame: 19
		// endFrame: 15
	},
	{
		sysName: 'foodThird',
		// cameraPos: [1410, 670, 1270],
		cameraPos: [930, 480, 1270],
		// cameraPos: [1425, 260, 760],
		// cameraPos: [1230, 540, 1170],
		// cameraPos: [1220, 230, 1400],
		rotationPos: [0, 0, 0],
		startFrame: 25.5,
		endFrame: 30
	},
	// {
	// 	sysName: 'foodThird2',
	// 	cameraPos: [1200, 515, 1260],
	// 	// cameraPos: [1230, 540, 1170],
	// 	// cameraPos: [1220, 230, 1400],
	// 	rotationPos: [0, 0, 0],
	// 	startFrame: 31,
	// 	endFrame: 38
	// },
	{
		sysName: 'last',
		cameraPos: [1425, 260, 760],
		// cameraPos: [1580, 280, 1200],
		// cameraPos: [1220, 430, 1200],
		// cameraPos: [1220, 230, 1400],
		rotationPos: [0, 0, 0],
		startFrame: 34,
		endFrame: 36.5
	},
	{
		sysName: 'end',
		// cameraPos: [900, 720, 1600],
		cameraPos: [1300, 860, 1600], // 1670, 800, 2200
		// cameraPos: [800, 720, 1600],
		// cameraPos: [1220, 230, 1400],
		rotationPos: [0, 0, 0],
		startFrame: 38.2,
		endFrame: 45
	},
	{
		sysName: 'null',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 100,
		endFrame: 100
	},
	{
		sysName: 'ready',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 100.15,
		endFrame: 100.15
	},
	{
		sysName: 'start',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 100.4,
		endFrame: 100.8
	},
	{
		sysName: 'pillOpen',
		cameraPos: [340, 600, 1700],
		rotationPos: [0, 0, 0],
		startFrame: 101.1,
		endFrame: 104
	},
	{
		sysName: 'foodFirst',
		cameraPos: [1030, 560, 1300],
		rotationPos: [0, 0, 0],
		startFrame: 108,
		endFrame: 112
	},
	{
		sysName: 'foodSecond',
		cameraPos: [1185, 360, 1330],
		rotationPos: [0, 0, 0],
		startFrame: 122.5, // 17
		endFrame: 123.5 // 18
	},
	{
		sysName: 'foodThird',
		cameraPos: [1425, 260, 760],
		rotationPos: [0, 0, 0],
		startFrame: 130.5, // 19
		endFrame: 132.5 // 21
	},
	{
		sysName: 'last',
		cameraPos: [1300, 860, 1600],
		rotationPos: [0, 0, 0],
		startFrame: 138.5, // 27
		endFrame: 139.5 // 28.5
	},
	{
		sysName: 'null',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 200,
		endFrame: 200
	},
	{
		sysName: 'ready',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 200.15,
		endFrame: 200.15
	},
	{
		sysName: 'start',
		cameraPos: [800, 760, 1600],
		rotationPos: [870, 700, 0],
		startFrame: 200.4,
		endFrame: 200.8
	},
	{
		sysName: 'pillOpen',
		// cameraPos: [340, 600, 1700],
		// cameraPos: [590, 620, 1870],
		cameraPos: [543, 551, 1700],
		rotationPos: [0, 0, 0],
		startFrame: 201.1,
		endFrame: 204
	},
	{
		sysName: 'foodFirst',
		// cameraPos: [1030, 560, 1300],
		// cameraPos: [1253, 433, 1300],
		cameraPos: [1167, 456, 1300],
		rotationPos: [0, 0, 0],
		startFrame: 217,
		endFrame: 221
	},
	// {
	// 	sysName: 'foodSecond',
	// 	cameraPos: [1185, 360, 1330],
	// 	rotationPos: [0, 0, 0],
	// 	startFrame: 222.5, // 17
	// 	endFrame: 223.5 // 18
	// },
	{
		sysName: 'foodThird',
		cameraPos: [1445, 260, 760],
		// cameraPos: [1527, 308, 950],
		// cameraPos: [1519, 260, 950],
		rotationPos: [0, 0, 0],
		startFrame: 233.5, // 19
		endFrame: 235.5 // 21
	},
	{
		sysName: 'last',
		cameraPos: [1340, 860, 1600],
		rotationPos: [0, 0, 0],
		startFrame: 245.5, // 27
		endFrame: 248.5 // 28.5
	}
];

// Данные для свойств камеры mobile kreon
const cameraPropertiesDataMobile = [
	{
		sysName: 'null',
		cameraPos: [235, -240, 3720],
		rotationPos: [870, 700, 0],
		startFrame: 0,
		endFrame: 0
	},
	{
		sysName: 'start',
		cameraPos: [240, -230, 3720],
		rotationPos: [870, 700, 0],
		startFrame: 0.1,
		endFrame: 0.4
	},
	{
		sysName: 'pillStarted',
		cameraPos: [175, -60, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 0.5,
		endFrame: 1
	},
	{
		sysName: 'pillOpen',
		cameraPos: [25, -240, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 7,
		endFrame: 10
	},
	{
		sysName: 'foodFirst',
		cameraPos: [545, -170, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 17,
		endFrame: 20
	},
	{
		sysName: 'foodSecond',
		cameraPos: [755, -170, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 27,
		endFrame: 32.5
	},
	{
		sysName: 'foodThird',
		cameraPos: [1295, -140, 2080],
		rotationPos: [0, 0, 0],
		startFrame: 39,
		endFrame: 42
	},
	{
		sysName: 'ferments',
		cameraPos: [1315, 120, 1340],
		rotationPos: [0, 0, 0],
		startFrame: 49,
		endFrame: 51
	},
	{
		sysName: 'last',
		cameraPos: [2000, 70, 1540],
		rotationPos: [0, 0, 0],
		startFrame: 65,
		endFrame: 66
	},
	{
		sysName: 'end',
		cameraPos: [900, 720, 1600],
		rotationPos: [0, 0, 0],
		startFrame: 68,
		endFrame: 69
	},
	{
		sysName: 'null',
		cameraPos: [235, -240, 3720],
		rotationPos: [870, 700, 0],
		startFrame: 80,
		endFrame: 90
	},
	{
		sysName: 'pillStarted',
		cameraPos: [175, -60, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 100.5,
		endFrame: 101
	},
	{
		sysName: 'pillOpen',
		cameraPos: [25, -240, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 107,
		endFrame: 110
	},
	{
		sysName: 'foodFirst',
		cameraPos: [545, -170, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 117,
		endFrame: 120
	},
	{
		sysName: 'foodSecond',
		cameraPos: [755, -170, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 125,
		endFrame: 130.5
	},
	{
		sysName: 'foodThird',
		cameraPos: [1295, -140, 2080],
		rotationPos: [0, 0, 0],
		startFrame: 137,
		endFrame: 140
	},
	{
		sysName: 'ferments',
		cameraPos: [1315, 120, 1340],
		rotationPos: [0, 0, 0],
		startFrame: 149,
		endFrame: 151
	},
	{
		sysName: 'last',
		cameraPos: [2000, 70, 1540],
		rotationPos: [0, 0, 0],
		startFrame: 164,
		endFrame: 165
	},
	{
		sysName: 'end',
		cameraPos: [900, 720, 1600],
		rotationPos: [0, 0, 0],
		startFrame: 167,
		endFrame: 168
	},
	{
		sysName: 'null',
		cameraPos: [235, -240, 3720],
		rotationPos: [870, 700, 0],
		startFrame: 180,
		endFrame: 190
	},
	{
		sysName: 'pillStarted',
		cameraPos: [175, -60, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 200.5,
		endFrame: 201
	},
	{
		sysName: 'pillOpen',
		cameraPos: [25, -240, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 210,
		endFrame: 213
	},
	{
		sysName: 'foodFirst',
		cameraPos: [545, -170, 3720],
		rotationPos: [0, 0, 0],
		startFrame: 220,
		endFrame: 223
	},
	// {
	// 	sysName: 'foodSecond',
	// 	cameraPos: [755, -170, 3720],
	// 	rotationPos: [0, 0, 0],
	// 	startFrame: 225,
	// 	endFrame: 230.5
	// },
	{
		sysName: 'foodThird',
		cameraPos: [1295, -140, 2080],
		rotationPos: [0, 0, 0],
		startFrame: 225,
		endFrame: 231.5
	},
	// {
	// 	sysName: 'ferments',
	// 	cameraPos: [1315, 120, 1340],
	// 	rotationPos: [0, 0, 0],
	// 	startFrame: 249,
	// 	endFrame: 251
	// },
	{
		sysName: 'last',
		cameraPos: [2000, 70, 1540],
		rotationPos: [0, 0, 0],
		startFrame: 251,
		endFrame: 253
	},
	{
		sysName: 'end',
		cameraPos: [900, 720, 1600],
		rotationPos: [0, 0, 0],
		startFrame: 255,
		endFrame: 256
	}
];

const updateItemsDataDesktop = [
	{
		itemSysName: 'stomachOn',
		animType: 'glow-pulse',
		fromFrame: 0,
		toFrame: 4,
		fromVal: GLOW_EFFECT,
		toVal: 4,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOff',
		animType: 'glow',
		fromFrame: 4,
		toFrame: 34.5, // 21
		fromVal: GLOW_EFFECT,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachStart',
		animType: 'glow',
		fromFrame: 98,
		toFrame: 100, // 21
		fromVal: 0,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOn2',
		animType: 'glow-pulse',
		fromFrame: 100,
		toFrame: 104,
		fromVal: GLOW_EFFECT,
		toVal: 4,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOff2',
		animType: 'glow',
		fromFrame: 104,
		toFrame: 132.5, // 21
		fromVal: GLOW_EFFECT,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachMesh',
		animType: 'fade',
		fromFrame: 100,
		toFrame: 100.5,
		fromVal: 0.3,
		toVal: 0.25,
		names: ['Geludok'],
		items: []
	},
	{
		itemSysName: 'slide01',
		animType: 'slide',
		fromFrame: 101.5,
		toFrame: 108.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide01'],
		items: []
	},
	{
		itemSysName: 'slide01_icon',
		animType: 'slide',
		fromFrame: 103.05,
		toFrame: 105.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slider .step2-svg1'],
		items: []
	},
	{
		itemSysName: 'slide02',
		animType: 'slide',
		fromFrame: 106.1,
		toFrame: 108.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide02'],
		items: []
	},
	{
		itemSysName: 'slide02_icon',
		animType: 'slide',
		fromFrame: 106.45,
		toFrame: 108.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide02 .step3-svg2'],
		items: []
	},
	{
		itemSysName: 'slide02-arrows',
		animType: 'slide',
		fromFrame: 106.6,
		toFrame: 108.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide02 .step3 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide03',
		animType: 'slide',
		fromFrame: 109,
		toFrame: 121.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide03'],
		items: []
	},
	{
		itemSysName: 'slide04',
		animType: 'slide',
		fromFrame: 109,
		toFrame: 121.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide04'],
		items: []
	},
	{
		itemSysName: 'slide04_icon',
		animType: 'slide',
		fromFrame: 116.3,
		toFrame: 121.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide04 .step4-svg1'],
		items: []
	},
	{
		itemSysName: 'slide04_icon',
		animType: 'slide',
		fromFrame: 116.3,
		toFrame: 121.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide03 .step4-svg2'],
		items: []
	},
	{
		itemSysName: 'slide05',
		animType: 'slide',
		fromFrame: 122,
		toFrame: 130.35,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide05'],
		items: []
	},
	{
		itemSysName: 'slide05_icon',
		animType: 'slide',
		fromFrame: 123.75,
		toFrame: 130.35,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide05 .step5-svg1'],
		items: []
	},
	{
		itemSysName: 'slide06',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06'],
		items: []
	},
	{
		itemSysName: 'slide06_icon',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-svg2'],
		items: []
	},
	{
		itemSysName: 'slide06_text',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-text'],
		items: []
	},
	{
		itemSysName: 'slide06_image',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-image'],
		items: []
	},
	{
		itemSysName: 'slide06_icon',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-svg1'],
		items: []
	},
	{
		itemSysName: 'slide06_next',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide06_prev',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 133.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6 .backto-button'],
		items: []
	},
	{
		itemSysName: 'slide07',
		animType: 'slide',
		fromFrame: 137,
		toFrame: 141,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide07'],
		items: []
	},
	{
		itemSysName: 'slide08',
		animType: 'slide',
		fromFrame: 2.3,
		toFrame: 7.3,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide08'],
		items: []
	},
	{
		itemSysName: 'slide09',
		animType: 'slide',
		fromFrame: 8.5,
		toFrame: 10.1,
		// fromFrame: 13.5,
		// toFrame: 15.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide09'],
		items: []
	},
	{
		itemSysName: 'slide09_icon',
		animType: 'slide',
		fromFrame: 8.5,
		toFrame: 10.1,
		// fromFrame: 13.5,
		// toFrame: 15.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide09 .step3-2-svg2'],
		items: []
	},
	{
		itemSysName: 'slide09-arrows',
		animType: 'slide',
		fromFrame: 8.5,
		toFrame: 10.1,
		// fromFrame: 13.5,
		// toFrame: 15.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide09 .step3 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide10',
		animType: 'slide',
		// fromFrame: 13,
		// toFrame: 21.5,
		fromFrame: 14,
		toFrame: 25.5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide10'],
		items: []
	},
	{
		itemSysName: 'slide10_icon',
		animType: 'slide',
		fromFrame: 19,
		toFrame: 25.5,
		// fromFrame: 14.8 + 5,
		// toFrame: 21.5 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide11 .step4-svg1'],
		items: []
	},
	{
		itemSysName: 'slide10_icon',
		animType: 'slide',
		fromFrame: 19,
		toFrame:  25.5,
		// fromFrame: 14.8 + 5,
		// toFrame: 21.5 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide10 .step4-svg2'],
		items: []
	},
	{
		itemSysName: 'slide11',
		animType: 'slide',
		fromFrame: 14,
		toFrame: 25.5,
		// fromFrame: 13 + 5,
		// toFrame: 21.5 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide11'],
		items: []
	},
	{
		itemSysName: 'slide12',
		animType: 'slide',
		fromFrame: 29.5,
		toFrame: 34.5,
		// fromFrame: 22.5 + 5,
		// toFrame: 32 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide12'],
		items: []
	},
	{
		itemSysName: 'slide12_icon',
		animType: 'slide',
		fromFrame: 30,
		toFrame: 34,
		// fromFrame: 23.5 + 5,
		// toFrame: 32 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide12 .step5-svg1'],
		items: []
	},
	{
		itemSysName: 'slide13',
		animType: 'slide',
		fromFrame: 35.5,
		toFrame: 38.1,
		// fromFrame: 36 + 5,
		// toFrame: 37.1 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13'],
		items: []
	},
	{
		itemSysName: 'slide13_icon',
		animType: 'slide',
		fromFrame: 36.5,
		toFrame: 38.1,
		// fromFrame: 36 + 5,
		// toFrame: 37.1 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6-svg2'],
		items: []
	},
	{
		itemSysName: 'slide13_text',
		animType: 'slide',
		fromFrame: 36.5,
		toFrame: 38.1,
		// fromFrame: 36 + 5,
		// toFrame: 37.1 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6-text'],
		items: []
	},
	// {
	// 	itemSysName: 'slide12_image',
	// 	animType: 'slide',
	// 	fromFrame: 31.5,
	// 	toFrame: 33.1,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide13 .step6-image'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide12_icon',
	// 	animType: 'slide',
	// 	fromFrame: 31.5,
	// 	toFrame: 33.1,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide13 .step6-svg1'],
	// 	items: []
	// },
	{
		itemSysName: 'slide13_next',
		animType: 'slide',
		fromFrame: 36.5,
		toFrame: 39.1,
		// fromFrame: 36 + 5,
		// toFrame: 37.1 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide13_prev',
		animType: 'slide',
		fromFrame: 36.5,
		toFrame: 39.1,
		// fromFrame: 36 + 5,
		// toFrame: 37.1 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6 .backto-button'],
		items: []
	},
	{
		itemSysName: 'slide14',
		animType: 'slide',
		fromFrame: 44.5,
		toFrame: 51,
		// fromFrame: 39 + 5,
		// toFrame: 42.15 + 5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide14'],
		items: []
	},

	{
		itemSysName: 'stomachStart2',
		animType: 'glow',
		fromFrame: 198,
		toFrame: 200, // 21
		fromVal: 0,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOn3',
		animType: 'glow-pulse',
		fromFrame: 200,
		toFrame: 204,
		fromVal: GLOW_EFFECT,
		toVal: 4,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOff3',
		animType: 'glow',
		fromFrame: 204,
		toFrame: 236.5, // 21
		fromVal: GLOW_EFFECT,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'slide15',
		animType: 'slide',
		fromFrame: 201.5,
		toFrame: 212.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide15'],
		items: []
	},
	{
		itemSysName: 'slide15_icon',
		animType: 'slide',
		fromFrame: 203.05,
		toFrame: 212.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slider .another-capsule .step2-svg1'],
		items: []
	},
	{
		itemSysName: 'slide16',
		animType: 'slide',
		fromFrame: 215.1,
		toFrame: 217.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide16'],
		items: []
	},
	{
		itemSysName: 'slide16_icon',
		animType: 'slide',
		fromFrame: 215.45,
		toFrame: 217.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide16 .step3-svg2'],
		items: []
	},
	{
		itemSysName: 'slide16-arrows',
		animType: 'slide',
		fromFrame: 215.6,
		toFrame: 217.2,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide16 .step3 .arrows'],
		items: []
	},
	// {
	// 	itemSysName: 'slide17',
	// 	animType: 'slide',
	// 	fromFrame: 209,
	// 	toFrame: 221.6,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide17'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide18',
	// 	animType: 'slide',
	// 	fromFrame: 209,
	// 	toFrame: 221.6,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide18'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide18_icon',
	// 	animType: 'slide',
	// 	fromFrame: 216.3,
	// 	toFrame: 221.6,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide18 .step4-svg1'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide18_icon',
	// 	animType: 'slide',
	// 	fromFrame: 216.3,
	// 	toFrame: 221.6,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide17 .step4-svg2'],
	// 	items: []
	// },
	{
		itemSysName: 'slide19',
		animType: 'slide',
		fromFrame: 218,
		toFrame: 230.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide19'],
		items: []
	},
	{
		itemSysName: 'slide19_icon',
		animType: 'slide',
		fromFrame: 220,
		toFrame: 230.6,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide19 .step5-svg1'],
		items: []
	},
	{
		itemSysName: 'slide20',
		animType: 'slide',
		fromFrame: 234.5,
		toFrame: 236.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20'],
		items: []
	},
	{
		itemSysName: 'slide20_icon',
		animType: 'slide',
		fromFrame: 234.5,
		toFrame: 236.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20 .step6-svg2'],
		items: []
	},
	{
		itemSysName: 'slide20_text',
		animType: 'slide',
		fromFrame: 234.5,
		toFrame: 236.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20 .step6-text'],
		items: []
	},
	// НЕ НУЖНО

	// {
	// 	itemSysName: 'slide20_image',
	// 	animType: 'slide',
	// 	fromFrame: 231.5,
	// 	toFrame: 233.1,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide20 .step6-image'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide20_icon',
	// 	animType: 'slide',
	// 	fromFrame: 231.5,
	// 	toFrame: 233.1,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide20 .step6-svg1'],
	// 	items: []
	// },
	{
		itemSysName: 'slide20_next',
		animType: 'slide',
		fromFrame: 234.5,
		toFrame: 236.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20 .step6 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide20_prev',
		animType: 'slide',
		fromFrame: 234.5,
		toFrame: 236.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20 .step6 .backto-button'],
		items: []
	},
	{
		itemSysName: 'slide21',
		animType: 'slide',
		fromFrame: 246.5,
		toFrame: 248.15,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide21'],
		items: []
	},
];

const updateItemsDataMobile = [
	{
		itemSysName: 'stomachOn',
		animType: 'glow-pulse',
		fromFrame: 0,
		toFrame: 4,
		fromVal: GLOW_EFFECT,
		toVal: 4,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOff',
		animType: 'glow',
		fromFrame: 4,
		toFrame: 49, // 21
		fromVal: GLOW_EFFECT,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachStart',
		animType: 'glow',
		fromFrame: 98,
		toFrame: 100, // 21
		fromVal: 0,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	// {
	// 	itemSysName: 'stomachOn2',
	// 	animType: 'glow-pulse',
	// 	fromFrame: 100,
	// 	toFrame: 104,
	// 	fromVal: GLOW_EFFECT,
	// 	toVal: 4,
	// 	names: ['highlight'],
	// 	items: []
	// },
	{
		itemSysName: 'stomachOff2',
		animType: 'glow',
		fromFrame: 100.15,
		toFrame: 149, // 21
		// toFrame: 132.5, // 21
		fromVal: GLOW_EFFECT,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachMesh',
		animType: 'fade',
		fromFrame: 100,
		toFrame: 100.5,
		fromVal: 0.3,
		toVal: 0.25,
		names: ['Geludok'],
		items: []
	},
	{
		itemSysName: 'slide01',
		animType: 'slide',
		fromFrame: 101.5,
		toFrame: 107,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide01'],
		items: []
	},
	{
		itemSysName: 'slide01_icon',
		animType: 'slide',
		fromFrame: 102,
		toFrame: 107,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide01 .step2-svg1'],
		items: []
	},
	{
		itemSysName: 'slide02',
		animType: 'slide',
		fromFrame: 110,
		toFrame: 117,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide02'],
		items: []
	},
	{
		itemSysName: 'slide02_icon',
		animType: 'slide',
		fromFrame: 110,
		toFrame: 117,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide02 .step3-svg2', '.step3-microsphere-icon-mobile'],
		items: []
	},
	{
		itemSysName: 'slide02-arrows',
		animType: 'slide',
		fromFrame: 112,
		toFrame: 117,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide02 .step3 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide03',
		animType: 'slide',
		fromFrame: 120,
		toFrame: 125,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide03'],
		items: []
	},
	{
		itemSysName: 'slide04',
		animType: 'slide',
		fromFrame: 130.5,
		toFrame: 137,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide04'],
		items: []
	},
	{
		itemSysName: 'slide04_icon',
		animType: 'slide',
		fromFrame: 131.5,
		toFrame: 137,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide04 .step4-svg1'],
		items: []
	},
	{
		itemSysName: 'slide04_icon',
		animType: 'slide',
		fromFrame: 121,
		toFrame: 125,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide03 .step4-svg2'],
		items: []
	},
	{
		itemSysName: 'slide05',
		animType: 'slide',
		fromFrame: 139.5,
		toFrame: 149,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide05'],
		items: []
	},
	{
		itemSysName: 'slide05_icon',
		animType: 'slide',
		fromFrame: 141,
		toFrame: 149,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide05 .step5-svg1'],
		items: []
	},
	{
		itemSysName: 'slide06',
		animType: 'slide',
		fromFrame: 151,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06'],
		items: []
	},
	{
		itemSysName: 'slide06_icon',
		animType: 'slide',
		fromFrame: 152,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-svg2'],
		items: []
	},
	{
		itemSysName: 'slide06_text',
		animType: 'slide',
		fromFrame: 152,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-text'],
		items: []
	},
	{
		itemSysName: 'slide06_image',
		animType: 'slide',
		fromFrame: 152,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-image'],
		items: []
	},
	{
		itemSysName: 'slide06_icon',
		animType: 'slide',
		fromFrame: 152,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6-svg1'],
		items: []
	},
	{
		itemSysName: 'slide06_next',
		animType: 'slide',
		fromFrame: 152,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide06_prev',
		animType: 'slide',
		fromFrame: 152,
		toFrame: 164,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide06 .step6 .backto-button'],
		items: []
	},
	{
		itemSysName: 'slide07',
		animType: 'slide',
		fromFrame: 164.6,
		toFrame: 167.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide07'],
		items: []
	},
	{
		itemSysName: 'slide08',
		animType: 'slide',
		fromFrame: 1.5,
		toFrame: 7,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide08'],
		items: []
	},
	{
		itemSysName: 'slide08_icon',
		animType: 'slide',
		fromFrame: 2,
		toFrame: 7,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide08 .step2-svg1'],
		items: []
	},
	{
		itemSysName: 'slide09',
		animType: 'slide',
		fromFrame: 10,
		toFrame: 19,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide09'],
		items: []
	},
	{
		itemSysName: 'slide09_icon',
		animType: 'slide',
		fromFrame: 12,
		toFrame: 19,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide09 .step3-2-svg2'],
		items: []
	},
	{
		itemSysName: 'slide09-arrows',
		animType: 'slide',
		fromFrame: 12,
		toFrame: 19,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide09 .step3 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide10',
		animType: 'slide',
		fromFrame: 20,
		toFrame: 31,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide10'],
		items: []
	},
	{
		itemSysName: 'slide11',
		animType: 'slide',
		fromFrame: 32.5,
		toFrame: 39,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide11'],
		items: []
	},
	{
		itemSysName: 'slide11_icon',
		animType: 'slide',
		fromFrame: 33.5,
		toFrame: 39,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide11 .step4-svg1'],
		items: []
	},
	{
		itemSysName: 'slide11_icon',
		animType: 'slide',
		fromFrame: 21,
		toFrame: 31,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide10 .step4-svg2'],
		items: []
	},
	{
		itemSysName: 'slide12',
		animType: 'slide',
		fromFrame: 42,
		toFrame: 49,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide12'],
		items: []
	},
	{
		itemSysName: 'slide12_icon',
		animType: 'slide',
		fromFrame: 43,
		toFrame: 49,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide12 .step5-svg1'],
		items: []
	},
	{
		itemSysName: 'slide13',
		animType: 'slide',
		fromFrame: 51,
		toFrame: 64,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13'],
		items: []
	},
	{
		itemSysName: 'slide13_icon',
		animType: 'slide',
		fromFrame: 52,
		toFrame: 64,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6-svg2'],
		items: []
	},
	{
		itemSysName: 'slide13_text',
		animType: 'slide',
		fromFrame: 52,
		toFrame: 64,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6-text'],
		items: []
	},
	// {
	// 	itemSysName: 'slide13_image',
	// 	animType: 'slide',
	// 	fromFrame: 52,
	// 	toFrame: 58,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide13 .step6-image'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide13_icon',
	// 	animType: 'slide',
	// 	fromFrame: 52,
	// 	toFrame: 58,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide13 .step6-svg1'],
	// 	items: []
	// },
	{
		itemSysName: 'slide13_next',
		animType: 'slide',
		fromFrame: 52,
		toFrame: 64,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6 .arrows'],
		items: []
	},
	{
		itemSysName: 'slide13_prev',
		animType: 'slide',
		fromFrame: 52,
		toFrame: 64,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide13 .step6 .backto-button'],
		items: []
	},
	{
		itemSysName: 'slide14',
		animType: 'slide',
		fromFrame: 65.4,
		toFrame: 67.1,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide14'],
		items: []
	},
	{
		itemSysName: 'stomachStart',
		animType: 'glow',
		fromFrame: 198,
		toFrame: 200, // 21
		fromVal: 0,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachOff3',
		animType: 'glow',
		fromFrame: 200.15,
		toFrame: 249, // 21
		// toFrame: 132.5, // 21
		fromVal: GLOW_EFFECT,
		toVal: 0,
		names: ['highlight'],
		items: []
	},
	{
		itemSysName: 'stomachMesh2',
		animType: 'fade',
		fromFrame: 200,
		toFrame: 200.5,
		fromVal: 0.3,
		toVal: 0.25,
		names: ['Geludok'],
		items: []
	},
	{
		itemSysName: 'slide15',
		animType: 'slide',
		fromFrame: 201.5,
		toFrame: 210,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide15'],
		items: []
	},
	{
		itemSysName: 'slide15_icon',
		animType: 'slide',
		fromFrame: 202,
		toFrame: 210,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide15 .step2-svg1'],
		items: []
	},
	{
		itemSysName: 'slide16',
		animType: 'slide',
		fromFrame: 213,
		toFrame: 220,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide16'],
		items: []
	},
	// {
	// 	itemSysName: 'slide16_icon',
	// 	animType: 'slide',
	// 	fromFrame: 210,
	// 	toFrame: 217,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide16 .step3-svg2'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide16-arrows',
	// 	animType: 'slide',
	// 	fromFrame: 212,
	// 	toFrame: 217,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide16 .step3 .arrows'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide17',
	// 	animType: 'slide',
	// 	fromFrame: 220,
	// 	toFrame: 225,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide17'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide18',
	// 	animType: 'slide',
	// 	fromFrame: 230.5,
	// 	toFrame: 237,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide18'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide18_icon',
	// 	animType: 'slide',
	// 	fromFrame: 231.5,
	// 	toFrame: 237,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide18 .step4-svg1'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide18_icon',
	// 	animType: 'slide',
	// 	fromFrame: 221,
	// 	toFrame: 225,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide17 .step4-svg2'],
	// 	items: []
	// },
	{
		itemSysName: 'slide19',
		animType: 'slide',
		fromFrame: 231.5,
		toFrame: 239.5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide19'],
		items: []
	},
	{
		itemSysName: 'slide19_icon',
		animType: 'slide',
		fromFrame: 233,
		toFrame: 239.5,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide19 .step5-svg1'],
		items: []
	},
	{
		itemSysName: 'slide20',
		animType: 'slide',
		fromFrame: 242,
		toFrame: 251,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20'],
		items: []
	},
	{
		itemSysName: 'slide20_icon',
		animType: 'slide',
		fromFrame: 243,
		toFrame: 251,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20 .step6-svg2'],
		items: []
	},
	{
		itemSysName: 'slide20_text',
		animType: 'slide',
		fromFrame: 243,
		toFrame: 251,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide20 .step6-text'],
		items: []
	},
	// {
	// 	itemSysName: 'slide20_image',
	// 	animType: 'slide',
	// 	fromFrame: 252,
	// 	toFrame: 264,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide20 .step6-image'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide20_icon',
	// 	animType: 'slide',
	// 	fromFrame: 252,
	// 	toFrame: 264,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide20 .step6-svg1'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide20_next',
	// 	animType: 'slide',
	// 	fromFrame: 252,
	// 	toFrame: 264,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide20 .step6 .arrows'],
	// 	items: []
	// },
	// {
	// 	itemSysName: 'slide20_prev',
	// 	animType: 'slide',
	// 	fromFrame: 252,
	// 	toFrame: 264,
	// 	// fromVal: 0,
	// 	// toVal: 1,
	// 	names: ['.slide20 .step6 .backto-button'],
	// 	items: []
	// },
	{
		itemSysName: 'slide21',
		animType: 'slide',
		fromFrame: 253,
		toFrame: 256,
		// fromVal: 0,
		// toVal: 1,
		names: ['.slide21'],
		items: []
	},
];

// Данные для callback desktop kreon
const callbackPropertiesDataDesktop = [
	{
		sysName: 'ready',
		action: function (frame) {
			animationProperties.pause();
			animationProperties.returnToFrame(START_FRAME);

			Timer.pause();
			Timer.returnToFrame(START_FRAME);

			updateItems.getItemsArray('stomachOff')[0].isEnabled = true;
		},
		doneAt: false,
		frame: START_FRAME
	},
	{
		sysName: 'slideOnePause',
		action: function (frame) {
			animationProperties.pause(true);
		},
		doneAt: false,
		frame: 2.3
	},
	{
		sysName: 'slideOnePlay',
		action: function (frame) {
			allowPlay = true;
			animationProperties.play();
		},
		doneAt: false,
		frame: 7.3
	},
	// {
	// 	sysName: 'glowOff',
	// 	action: function (frame) {
	// 		updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
	// 	},
	// 	doneAt: false,
	// 	frame: 21
	// },
	// {
	// 	sysName: 'hideSphere',
	// 	action: function (frame) {
	// 		$('.pill .step2-svg1').removeClass('js-showed');
	// 		$('.pill .step2-description').removeClass('js-showed');
	// 	},
	// 	doneAt: false,
	// 	frame: 5.5
	// },
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.pause();
			Timer.pause();

			document.querySelector(`.another-pill .arrows-icon-item-circle`).style.pointerEvents = `all`;
			document.querySelector(`.another-pill .arrows-icon-item-circle`).style.cursor = `pointer`;
		},
		doneAt: false,
		frame: 9.5 // 7.6 old value
		// frame: 14.5 // 7.6 old value
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			document.querySelector(`.another-pill .arrows-icon-item-circle`).style.pointerEvents = `none`;
			document.querySelector(`.another-pill .arrows-icon-item-circle`).style.cursor = ``;
		},
		doneAt: false,
		frame: 10.2 // 7.6 old value
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.pause(true);
		},
		doneAt: false,
		frame: 19 // 15
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			allowPlay = true;
			animationProperties.play();
		},
		doneAt: false,
		frame: 25.5 // 21.5
		// frame: 21.5 + 5
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.pause(true);
		},
		doneAt: false,
		frame: 30 // 30
		// frame: 24 + 5
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			// updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
			allowPlay = true;
			animationProperties.play();
		},
		doneAt: false,
		frame: 34.5
		// frame: 32 + 5
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.pause();
			Timer.pause();

			document.querySelector(`.another-pill.step6 .arrows-icon-item-circle`).style.pointerEvents = `all`;
			document.querySelector(`.another-pill.step6 .backto-button`).style.pointerEvents = `all`;
			document.querySelector(`.another-pill.step6 .arrows-icon-item-circle`).style.cursor = `pointer`;
			document.querySelector(`.another-pill.step6 .backto-button`).style.cursor = `pointer`;
		},
		doneAt: false,
		frame: 37.5 //45.5
		// frame: 36.5 + 5
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			// updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
			animationProperties.play();
		},
		doneAt: false,
		frame: 38
		// frame: 32 + 5
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			document.querySelector(`.another-pill.step6 .arrows-icon-item-circle`).style.pointerEvents = `none`;
			document.querySelector(`.another-pill.step6 .backto-button`).style.pointerEvents = `none`;
			document.querySelector(`.another-pill.step6 .arrows-icon-item-circle`).style.cursor = ``;
			document.querySelector(`.another-pill.step6 .backto-button`).style.cursor = ``;
		},
		doneAt: false,
		frame: 42.7 // 46.2
		// frame: 36.5 + 5
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			globalScene.executeWhenReady(() => {
				animationProperties.pause(true);
			});
			document.querySelector('.another-pill .step7-btn.pills').style.pointerEvents = 'none';
			// document.querySelector('.another-pill .step7-link').style.pointerEvents = 'none';
		},
		doneAt: false,
		frame: 41 // 47.5
		// frame: 36.5 + 5
	},

	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			document.querySelectorAll('.another-pill .step7-btn.newly').forEach((item) => {
				item.style.pointerEvents = `all`;
				item.style.cursor = `pointer`;
			});
			document.querySelector('.another-pill .step7-btn.pills').style.pointerEvents = 'all';
			// document.querySelector('.another-pill .step7-link').style.pointerEvents = 'all';

			globalScene.executeWhenReady(() => {
				Timer.pause();
			});
		},
		doneAt: false,
		frame: 45
		// frame: 36.5 + 5
	},
	// {
	// 	sysName: 'showSlideThreePartOne',
	// 	action: function (frame) {
	// 		animationProperties.pause();
	//
	// 		setTimeout(() => {
	// 			$('.slider .step4-svg2').addClass('js-showed');
	// 		}, 800);
	//
	// 		setTimeout(() => {
	// 			$('.slider .step4-svg1').addClass('js-showed');
	// 		}, 800);
	//
	// 		setTimeout(() => {
	// 			hideSlides();
	// 			animationProperties.play();
	// 		}, 7500);
	// 	},
	// 	doneAt: false,
	// 	frame: 14
	// },
	// {
	// 	sysName: 'openSlideFive',
	// 	action: function (frame) {
	// 		openSlide(5);
	// 	},
	// 	doneAt: false,
	// 	frame: 15
	// },
	// {
	// 	sysName: 'showSlideFiveCircleAndPause',
	// 	action: function (frame) {
	// 		$('.slider .step5-svg1').addClass('js-showed');
	//
	// 		animationProperties.pause();
	//
	// 		setTimeout(() => {
	// 			hideSlides();
	// 			animationProperties.play();
	// 		}, 8000);
	// 	},
	// 	doneAt: false,
	// 	frame: 16.5 // 18.75 old value
	// },
	// {
	// 	sysName: 'hideSlideFive',
	// 	action: function (frame) {
	// 		// openSlide(6);
	// 	},
	// 	doneAt: false,
	// 	frame: 19.5
	// },
	// {
	// 	sysName: 'hideSlideFive',
	// 	action: function (frame) {
	// 		animationProperties.pause();
	//
	// 		setTimeout(() => {
	// 			// $('.slider .step6-image').addClass('js-showed');
	// 			// $('.slider .step6-svg1').addClass('js-showed');
	// 		}, 1000);
	//
	// 		// setTimeout(() => {
	// 		openSlide(6);
	// 		$('.slider .step6-svg2').addClass('js-showed');
	// 		$('.slider .step6-text').addClass('js-showed');
	// 		$('.slider .step6-image').addClass('js-showed');
	// 		$('.slider .step6-svg1').addClass('js-showed');
	// 		$('.step6 .arrows').addClass('js-showed');
	// 		$('.step6 .backto-button').addClass('js-showed');
	// 		// }, 1300);
	//
	// 		// $('.slider .step6-svg2').addClass('js-showed');
	// 		// $('.slider .step6-text').addClass('js-showed');
	// 	},
	// 	doneAt: false,
	// 	frame: 21
	// },
	// {
	// 	sysName: 'stopFoodMoving',
	// 	action: function (frame) {
	// 		// stop food moving
	// 		animationProperties.animation.forEach((item) => {
	// 			if (item.uniqueId === 406) {
	// 				item.pause();
	// 			}
	// 		});
	// 	},
	// 	doneAt: false,
	// 	frame: 25
	// },
	// {
	// 	sysName: 'slideFive',
	// 	action: function (frame) {
	// 		openSlide(7);
	//
	// 		animationProperties.pause();
	//
	// 		$('.slider .step4-svg1').removeClass('js-showed');
	// 		$('.slider .step4-svg2').removeClass('js-showed');
	// 		$('.slider .step5-svg1').removeClass('js-showed');
	// 		$('.slider .step6-svg1').removeClass('js-showed');
	// 		$('.slider .step6-svg2').removeClass('js-showed');
	// 		$('.slider .step6-image').removeClass('js-showed');
	// 		$('.slider .step2-microsphere-icon').removeClass('step2-microsphere-icon-show');
	// 		$('.step6 .backto-button').removeClass('js-showed');
	// 		// document.querySelector('.slider .step6-image').style.visibility = 'hidden';
	// 		// removeAnimatiomImage();
	// 	},
	// 	doneAt: false,
	// 	frame: 28.25
	// },
	{
		sysName: 'slideOne',
		action: function (frame) {
			// openSlide(1);
			$('.slider .step2-microsphere-icon').addClass('step2-microsphere-icon-show');
		},
		doneAt: false,
		frame: 102
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.pause();
			Timer.pause();

			//ff opacity fix
			// document.querySelector('.slide02').style.opacity = 1;
			// document.querySelector('.slider .step3-svg2').style.opacity = 1;
			// document.querySelector('.step3 .arrows').style.opacity = 1;

			// $('.step3 .arrows').addClass('js-showed');
			document.querySelector(`.kreon-capsule .arrows-icon-item-circle`).style.pointerEvents = `all`;
			document.querySelector(`.kreon-capsule .arrows-icon-item-circle`).style.cursor = `pointer`;
		},
		doneAt: false,
		frame: 107.6
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			// openSlide(3);
			// openSlide(4);
			document.querySelector(`.kreon-capsule .arrows-icon-item-circle`).style.pointerEvents = `none`;
			document.querySelector(`.kreon-capsule .arrows-icon-item-circle`).style.cursor = `none`;
		},
		doneAt: false,
		frame: 108.6
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.pause(true);
			console.log('test render')
		},
		doneAt: false,
		frame: 116
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			allowPlay = true;
			animationProperties.play();
		},
		doneAt: false,
		frame: 121.5
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			updateItems.getItemsArray('stomachOff2')[0].isEnabled = false;
		},
		doneAt: false,
		frame: 132.5
	},
	{
		sysName: 'showSlideFiveCircleAndPause',
		action: function (frame) {
			// $('.slider .step5-svg1').addClass('js-showed');

			animationProperties.pause(true);
		},
		doneAt: false,
		frame: 124.25 // 18.75
	},
	{
		sysName: 'showSlideFiveCircleAndPause',
		action: function (frame) {
			allowPlay = true;
			animationProperties.play();
		},
		doneAt: false,
		frame: 130.25 // 18.75
	},
	{
		sysName: 'showSlideFiveCircleAndPause',
		action: function (frame) {
			refreshImageAnimation();
		},
		doneAt: false,
		frame: 131.5
	},
	{
		sysName: 'hideSlideFive',
		action: function (frame) {
			animationProperties.pause();
			Timer.pause();

			document.querySelector(`.kreon-capsule.step6 .arrows-icon-item-circle`).style.pointerEvents = `all`;
			document.querySelector(`.kreon-capsule.step6 .backto-button`).style.pointerEvents = `all`;
			document.querySelector(`.kreon-capsule.step6 .arrows-icon-item-circle`).style.cursor = `pointer`;
			document.querySelector(`.kreon-capsule.step6 .backto-button`).style.cursor = `pointer`;
		},
		doneAt: false,
		frame: 132.5
	},
	{
		sysName: 'hideSlideFive',
		action: function (frame) {

			document.querySelector(`.kreon-capsule.step6 .arrows-icon-item-circle`).style.pointerEvents = `none`;
			document.querySelector(`.kreon-capsule.step6 .backto-button`).style.pointerEvents = `none`;
			document.querySelector(`.kreon-capsule.step6 .arrows-icon-item-circle`).style.cursor = `none`;
			document.querySelector(`.kreon-capsule.step6 .backto-button`).style.cursor = `none`;
		},
		doneAt: false,
		frame: 133.5
	},
	{
		sysName: 'slideFive',
		action: function (frame) {
			// openSlide(7);

			globalScene.executeWhenReady(() => {
				animationProperties.pause(true);
				Timer.pause();
			});

			document.querySelectorAll('.kreon-capsule .step7-btn.newly').forEach((item) => {
				item.style.pointerEvents = `all`;
				item.style.cursor = `pointer`;
			});
			document.querySelector('.kreon-capsule .step7-btn.pills').style.pointerEvents = 'all';
			document.querySelector('.kreon-capsule .step7-link').style.pointerEvents = 'all';
		},
		doneAt: false,
		frame: 139.5
	},

	{
		sysName: 'slideOne',
		action: function (frame) {
			// openSlide(1);
			// $('.slider .step2-microsphere-icon').addClass('step2-microsphere-icon-show');
			animationProperties.pause(true);
		},
		doneAt: false,
		frame: 203.6
	},
	{
		sysName: 'slideOneContinue',
		action: function (frame) {
			allowPlay = true;
			animationProperties.play(true);
		},
		doneAt: false,
		frame: 212.6
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.pause();
			Timer.pause();

			//ff opacity fix
			// document.querySelector('.slide02').style.opacity = 1;
			// document.querySelector('.slider .step3-svg2').style.opacity = 1;
			// document.querySelector('.step3 .arrows').style.opacity = 1;

			// $('.step3 .arrows').addClass('js-showed');
			document.querySelector(`.another-capsule .arrows-icon-item-circle`).style.pointerEvents = `all`;
			document.querySelector(`.another-capsule .arrows-icon-item-circle`).style.cursor = `pointer`;
		},
		doneAt: false,
		frame: 216.6
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			// openSlide(3);
			// openSlide(4);
			document.querySelector(`.another-capsule .arrows-icon-item-circle`).style.pointerEvents = `none`;
			document.querySelector(`.another-capsule .arrows-icon-item-circle`).style.cursor = `none`;
		},
		doneAt: false,
		frame: 217.6
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.pause(true);
		},
		doneAt: false,
		frame: 220
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			allowPlay = true;
			animationProperties.play();
		},
		doneAt: false,
		frame: 230.5
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			updateItems.getItemsArray('stomachOff2')[0].isEnabled = false;
		},
		doneAt: false,
		frame: 241.5
	},
	// {
	// 	sysName: 'showSlideFiveCircleAndPause',
	// 	action: function (frame) {
	// 		// $('.slider .step5-svg1').addClass('js-showed');
	//
	// 		animationProperties.pause();
	// 	},
	// 	doneAt: false,
	// 	frame: 224.25 // 18.75
	// },
	// {
	// 	sysName: 'showSlideFiveCircleAndPause',
	// 	action: function (frame) {
	// 		animationProperties.play();
	// 	},
	// 	doneAt: false,
	// 	frame: 230.25 // 18.75
	// },
	{
		sysName: 'hideSlideFive',
		action: function (frame) {
			animationProperties.pause();
			Timer.pause();

			document.querySelector(`.another-capsule.step6 .arrows-icon-item-circle`).style.pointerEvents = `all`;
			document.querySelector(`.another-capsule.step6 .backto-button`).style.pointerEvents = `all`;
			document.querySelector(`.another-capsule.step6 .arrows-icon-item-circle`).style.cursor = `pointer`;
			document.querySelector(`.another-capsule.step6 .backto-button`).style.cursor = `pointer`;
			refreshImageAnimation();
		},
		doneAt: false,
		frame: 235.5
	},
	{
		sysName: 'hideSlideFive',
		action: function (frame) {

			document.querySelector(`.another-capsule.step6 .arrows-icon-item-circle`).style.pointerEvents = `none`;
			document.querySelector(`.another-capsule.step6 .backto-button`).style.pointerEvents = `none`;
			document.querySelector(`.another-capsule.step6 .arrows-icon-item-circle`).style.cursor = `none`;
			document.querySelector(`.another-capsule.step6 .backto-button`).style.cursor = `none`;
		},
		doneAt: false,
		frame: 236.5
	},
	{
		sysName: 'slideFive',
		action: function (frame) {
			// openSlide(7);

			globalScene.executeWhenReady(() => {
				animationProperties.pause(true);
				Timer.pause();
			});

			document.querySelector('.another-capsule .step7-btn.pills').style.pointerEvents = 'all';

			document.querySelectorAll('.another-capsule .step7-btn.newly').forEach((item) => {
				item.style.pointerEvents = `all`;
				item.style.cursor = `pointer`;
			});
		},
		doneAt: false,
		frame: 247.2
	}
];

// Функция для таймера
let timerOne;
let timerTwo;
let timerThree;
let timerFour;
let timerFive;
let timerSix;
let timerSeven;

// // Класс таймера для установки паузы и воозобновления таймеров
// class Timer {
// 	/**
// 	 *
// 	 * @param {Function} callback функция обратного вызова, для таймера.
// 	 * @param {Number} delay время в милисекундах.
// 	 */
// 	constructor(callback, delay) {
// 		this.callback = callback;
// 		this.remainingTime = delay;
// 		this.startTime;
// 		this.timerId;
// 	}

// 	pause() {
// 		clearTimeout(this.timerId);
// 		this.remainingTime -= new Date() - this.startTime;
// 	}

// 	resume() {
// 		clearTimeout(this.timerId);
// 		this.startTime = new Date();
// 		this.timerId = setTimeout(this.callback, this.remainingTime);
// 	}

// 	start() {
// 		this.timerId = setTimeout(this.callback, this.remainingTime);
// 	}

// 	clear() {
// 		clearTimeout(this.timerId);
// 	}
// }

// Данные для callback mobile kreon
const callbackPropertiesDataMobile = [
	{
		sysName: 'ready',
		action: function (frame) {
			animationProperties.pause();
			animationProperties.returnToFrame(START_FRAME);

			Timer.pause();
			Timer.returnToFrame(START_FRAME);

			updateItems.getItemsArray('stomachOff')[0].isEnabled = true;
		},
		doneAt: false,
		frame: START_FRAME
	},
	// {
	// 	sysName: 'start',
	// 	action: function (frame) {
	// 		// updateItems.getItemsArray('stomachOff')[0].isEnabled = true;
	// 		// $('.slider .step2-svg1').addClass('js-showed');
	// 		// render.classList.remove('render-mobile');
	// 	},
	// 	doneAt: false,
	// 	frame: START_FRAME
	// },
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 1.2
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 7
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.pause();
			// $('.slider .step3-svg2').addClass('js-showed');
			// $('.slider .step3-microsphere-icon-mobile').addClass('js-showed');
		},
		doneAt: false,
		frame: 10
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 17
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.pause();
			// timerThree = setTimeout(() => {
			// 	if (allowTimer) {
			// 		// hideSlides();
			// 		animationProperties.play();
			// 	}
			// 	allowTimer = true;
			// }, 7000);
			//
			// timerFour = setTimeout(() => {
			// 	hideSlides();
			// }, 10000);
		},
		doneAt: false,
		frame: 20
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 27
	},
	{
		sysName: 'hideSlideFour',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 32.5
	},
	{
		sysName: 'hideSlideFour',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 39
	},
	{
		sysName: 'hideSlideFive',
		action: function (frame) {
			animationProperties.pause();
			updateItems.getItemsArray('stomachOff')[0].isEnabled = true;

			// timerSix = new Timer(() => {
			// 	if (allowTimer) {
			// 		hideSlides();
			// 		animationProperties.play();
			// 	}
			// 	allowTimer = true;
			// }, 7000);
		},
		doneAt: false,
		frame: 42
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			animationProperties.play();
			updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
		},
		doneAt: false,
		frame: 49
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
			refreshImageAnimation();
			animationProperties.pause();
		},
		doneAt: false,
		frame: 51
	},
	{
		sysName: 'slideFive',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 58
	},
	{
		sysName: 'slideFive',
		action: function (frame) {
			document.querySelector('.slider').style.pointerEvents = 'all';
			document.querySelector('.kreon-capsule.step7').classList.add('scroll');
		},
		doneAt: false,
		frame: 62
	},
	{
		sysName: 'last',
		action: function (frame) {
			render.classList.add('render-mobile');
			// render.style.touchAction = 'auto';
			repeatButtonMobile.style.display = 'flex';
			document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'all';
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'all';
			startKreonButtonMobile.style.pointerEvents = 'all';
			startKreonButtonMobile.style.display = 'block';
			if (!document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
				document.querySelector('.slider-footer').classList.add('at-last-slide');
			}
			filterGradient.style.display = 'none';
		},
		doneAt: false,
		frame: 65
	},
	{
		sysName: 'last',
		action: function (frame) {
			// Очистка предыдущих таймеров
			// clearTimeout(timerSeven);
			// timerSeven.clear();

			// openSlide(7);
			filterGradient.style.display = 'none';

			document.querySelectorAll('.kreon-capsule .step7-btn.newly').forEach((item) => {
				item.style.pointerEvents = `none`;
				item.style.cursor = `none`;
			});
			document.querySelector('.kreon-capsule .step7-btn.pills').style.pointerEvents = 'none';
			document.querySelector('.another-pill .step7-btn.pills').style.pointerEvents = 'none';
			document.querySelector('.kreon-capsule .step7-link').style.pointerEvents = 'none';
			// document.querySelector('.another-pill .step7-link').style.pointerEvents = 'none';


			animationProperties.pause();
			Timer.pause();
			// render.classList.add('render-mobile');
			// repeatButtonMobile.style.display = 'flex';
			// filterGradient.style.display = 'none';
			document.querySelector('.slider').style.pointerEvents = 'all';
			document.querySelector('.kreon-capsule.step7').classList.add('scroll');
			document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'all';
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'all';
			startKreonButtonMobile.style.pointerEvents = 'all';
			startKreonButtonMobile.style.display = 'block';
			if (!document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
				document.querySelector('.slider-footer').classList.add('at-last-slide');
			}
			allowTimer = false;
		},
		doneAt: false,
		frame: 66
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 101.2
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 107
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.pause();
			// $('.slider .step3-svg2').addClass('js-showed');
			// $('.slider .step3-microsphere-icon-mobile').addClass('js-showed');
		},
		doneAt: false,
		frame: 110
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 117
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.pause();
			// timerThree = setTimeout(() => {
			// 	if (allowTimer) {
			// 		// hideSlides();
			// 		animationProperties.play();
			// 	}
			// 	allowTimer = true;
			// }, 7000);
			//
			// timerFour = setTimeout(() => {
			// 	hideSlides();
			// }, 10000);
		},
		doneAt: false,
		frame: 120
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 125
	},
	{
		sysName: 'hideSlideFour',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 130.5
	},
	{
		sysName: 'hideSlideFour',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 137
	},
	{
		sysName: 'hideSlideFive',
		action: function (frame) {
			animationProperties.pause();
			updateItems.getItemsArray('stomachOff')[0].isEnabled = true;

			// timerSix = new Timer(() => {
			// 	if (allowTimer) {
			// 		hideSlides();
			// 		animationProperties.play();
			// 	}
			// 	allowTimer = true;
			// }, 7000);
		},
		doneAt: false,
		frame: 140
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
		},
		doneAt: false,
		frame: 147
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 149
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
			refreshImageAnimation();
			animationProperties.pause();
		},
		doneAt: false,
		frame: 151
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			// refreshImageAnimation();
			animationProperties.pause();
		},
		doneAt: false,
		frame: 153
	},
	{
		sysName: 'slideFive',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 159
	},
	{
		sysName: 'slideFive',
		action: function (frame) {
			// filterGradient.style.display = 'none';

			document.querySelector('.slider').style.pointerEvents = 'all';
			document.querySelector('.kreon-capsule.step7').classList.add('scroll');
		},
		doneAt: false,
		frame: 164
	},
	{
		sysName: 'last',
		action: function (frame) {
			render.classList.add('render-mobile');
			// render.style.touchAction = 'auto';
			repeatButtonMobile.style.display = 'flex';
			document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'all';
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'all';
			startPillButtonMobile.style.pointerEvents = 'all';
			startPillButtonMobile.style.display = 'block';
			if (!document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
				document.querySelector('.slider-footer').classList.add('at-last-slide');
			}
			filterGradient.style.display = 'none';

			// document.querySelector('.slider').style.pointerEvents = 'all';
			// document.querySelector('.kreon-capsule.step7').classList.add('scroll');
		},
		doneAt: false,
		frame: 165
	},
	{
		sysName: 'last',
		action: function (frame) {
			// Очистка предыдущих таймеров
			// clearTimeout(timerSeven);
			// timerSeven.clear();

			// openSlide(7);
			document.querySelectorAll('.kreon-capsule .step7-btn.newly').forEach((item) => {
				item.style.pointerEvents = `none`;
				item.style.cursor = `none`;
			});
			document.querySelector('.kreon-capsule .step7-btn.pills').style.pointerEvents = 'none';
			document.querySelector('.kreon-capsule .step7-link').style.pointerEvents = 'none';
			animationProperties.pause();
			Timer.pause();
			// render.classList.add('render-mobile');
			// repeatButtonMobile.style.display = 'flex';
			// filterGradient.style.display = 'none';
			allowTimer = false;
		},
		doneAt: false,
		frame: 166
	},

	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 201.2
	},
	{
		sysName: 'showSlideThreePartOne',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 210
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.pause();
			// $('.slider .step3-svg2').addClass('js-showed');
			// $('.slider .step3-microsphere-icon-mobile').addClass('js-showed');
		},
		doneAt: false,
		frame: 213
	},
	{
		sysName: 'showSlideThreePartTwo',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 220
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			// animationProperties.pause();
			// timerThree = setTimeout(() => {
			// 	if (allowTimer) {
			// 		// hideSlides();
			// 		animationProperties.play();
			// 	}
			// 	allowTimer = true;
			// }, 7000);
			//
			// timerFour = setTimeout(() => {
			// 	hideSlides();
			// }, 10000);
		},
		doneAt: false,
		frame: 223
	},
	{
		sysName: 'pauseAtEndOfThirdSlide',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 224
	},
	{
		sysName: 'hideSlideFour',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 232
	},
	{
		sysName: 'hideSlideFour',
		action: function (frame) {
			animationProperties.play();
		},
		doneAt: false,
		frame: 239.5
	},
	{
		sysName: 'hideSlideFive',
		action: function (frame) {
			// animationProperties.pause();
			// updateItems.getItemsArray('stomachOff')[0].isEnabled = true;

			startKreonButtonMobile.style.pointerEvents = 'none';
			startKreonButtonMobile.style.display = 'none';
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'none';

			// timerSix = new Timer(() => {
			// 	if (allowTimer) {
			// 		hideSlides();
			// 		animationProperties.play();
			// 	}
			// 	allowTimer = true;
			// }, 7000);
		},
		doneAt: false,
		frame: 241.5
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
		},
		doneAt: false,
		frame: 250
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			animationProperties.pause();
		},
		doneAt: false,
		frame: 251
	},
	{
		sysName: 'glowOff',
		action: function (frame) {
			// updateItems.getItemsArray('stomachOff')[0].isEnabled = false;
			// animationProperties.pause();
		},
		doneAt: false,
		frame: 254
	},
	// {
	// 	sysName: 'glowOff',
	// 	action: function (frame) {
	// 		// refreshImageAnimation();
	// 		animationProperties.pause();
	// 	},
	// 	doneAt: false,
	// 	frame: 253
	// },
	// {
	// 	sysName: 'slideFive',
	// 	action: function (frame) {
	// 		animationProperties.play();
	// 	},
	// 	doneAt: false,
	// 	frame: 259
	// },
	// {
	// 	sysName: 'slideFive',
	// 	action: function (frame) {
	// 		// filterGradient.style.display = 'none';
	// 		animationProperties.pause();
	// 		document.querySelector('.slider').style.pointerEvents = 'all';
	// 		// document.querySelector('.another-capsule.step7').classList.add('scroll');
	// 	},
	// 	doneAt: false,
	// 	frame: 249
	// },
	{
		sysName: 'last',
		action: function (frame) {
			document.querySelector('.slider').style.pointerEvents = 'all';
			render.classList.add('render-mobile');
			repeatButtonMobile.style.display = 'flex';
			startKreonButtonMobile.style.pointerEvents = 'all';
			startKreonButtonMobile.style.display = 'block';
			document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'all';
			if (!document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
				document.querySelector('.slider-footer').classList.add('at-last-slide');
			}
			filterGradient.style.display = 'none';

			// document.querySelector('.slider').style.pointerEvents = 'all';
			// document.querySelector('.kreon-capsule.step7').classList.add('scroll');
		},
		doneAt: false,
		frame: 252
	},
	{
		sysName: 'last',
		action: function (frame) {
			// Очистка предыдущих таймеров
			// clearTimeout(timerSeven);
			// timerSeven.clear();

			// openSlide(7);
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'all';
			document.querySelectorAll('.another-capsule .step7-btn.newly').forEach((item) => {
				item.style.pointerEvents = `none`;
				item.style.cursor = `none`;
			});
			animationProperties.pause();
			Timer.pause();
			// render.classList.add('render-mobile');
			// repeatButtonMobile.style.display = 'flex';
			// filterGradient.style.display = 'none';
			allowTimer = false;
		},
		doneAt: false,
		frame: 253.6
	}
];

// Изменение данных при изменении ширины окна
const changeDataByWindowSize = {
	/**
	 * @description получает данные для свойств камеры по условию.
	 * @returns возвращает объект с данными для свойств камеры.
	 */
	getCameraPropertiesData: function () {
		if (isDesktopSize) {
			return cameraPropertiesDataDesktop;
		} else if (isMobileSize) {
			return cameraPropertiesDataMobile;
		}
	},
	/**
	 * @description получает данные callback по условию.
	 * @returns возвращает объект с данными callback.
	 */
	getCallbackPropertiesData: function () {
		if (isDesktopSize) {
			return callbackPropertiesDataDesktop;
		} else if (isMobileSize) {
			return callbackPropertiesDataMobile;
		}
	},
	/**
	 * @description получает данные обновления объектов по условию.
	 * @returns возвращает объект с данными обновления объектов.
	 */
	getUpdateItemsData: function () {
		if (isDesktopSize) {
			return updateItemsDataDesktop;
		} else if (isMobileSize) {
			return updateItemsDataMobile;
		}
	},
	/**
	 * @description получает ширину и высоту для фона сцены.
	 * @returns возвращает объект с параметрами ширины и высоты для фона сцены.
	 */
	getBgPlaneSizeData: function () {
		if (isDesktopSize) {
			let tmpObj = {
				width: 10000,
				height: 2500
			}

			return tmpObj
		}
		if (isMobileSize) {
			let tmpObj = {
				width: 18000,
				height: 5000
			}

			return tmpObj
		}
	}
};

// Текущие данные для свойств камеры
let cameraProperties = changeDataByWindowSize.getCameraPropertiesData();

var tempCamPos = false;

var iCnt, jCnt, fCnt;
var cpLen = cameraProperties.length;
var cpProp;
var tmpCoordsFrom, tmpCoordsTo, tmpCoordsCur;
var curNormal;

// Движение камеры
const cameraMoving = {
	getIndexByFrame: function (frame) {
		for (iCnt = cpLen - 1; iCnt > 0; iCnt--) {
			cpProp = cameraProperties[iCnt];
			if (cpProp.startFrame < frame) {
				break;
			}
		}

		return iCnt;
	},
	getCurrentPropertyByFrame: function (frame) {
		return cameraProperties[this.getIndexByFrame(frame)];
	},
	getPreviousPropertyByFrame: function (frame) {
		fCnt = this.getIndexByFrame(frame) - 1;

		return cameraProperties[fCnt < 0 ? 0 : fCnt];
	},
	isCameraInInterval: function (frame) {
		cpProp = this.getCurrentPropertyByFrame(frame);

		return cpProp.startFrame == frame || cpProp.endFrame == frame ? false : true;
	},
	getIntervalNormal: function (frame) {
		cpProp = this.getCurrentPropertyByFrame(frame);
		curNormal = ((frame - cpProp.startFrame) / (cpProp.endFrame - cpProp.startFrame));

		return (curNormal < 1 ? curNormal : 1);
	},
	getCameraPos: function (frame) {
		tmpCoordsFrom = [...this.getPreviousPropertyByFrame(frame).cameraPos];
		tmpCoordsTo = [...this.getCurrentPropertyByFrame(frame).cameraPos];
		curNormal = this.getIntervalNormal(frame);

		if (curNormal == 1) {
			tmpCoordsCur = tmpCoordsTo;
		} else if (curNormal == 0) {
			tmpCoordsCur = tmpCoordsFrom;
		} else {
			for (jCnt = 0; jCnt <= 2; jCnt++) {
				tmpCoordsCur[jCnt] = ((tmpCoordsTo[jCnt] - tmpCoordsFrom[jCnt]) * Math.sin(Math.PI / 2 * curNormal)) + tmpCoordsFrom[jCnt];
			}
		}

		return tmpCoordsCur;
	}
};

// Свойства анимаций
const animationProperties = {
	animation: [],
	paused: false,
	/**
	 * @description ставит на паузу все группы анимаций.
	 */
	pause: function (blockPlay = false) {
		this.animation.forEach((item) => {
			item.pause();
		});

		this.paused = true;

		if (blockPlay) {
			allowPlay = false;
			console.log(`allowPlay - ${allowPlay}`)
		}
	},
	/**
	 * @description воспроизводит все группы анимаций.
	 */
	play: function () {
		if (allowPlay) {
			this.animation.forEach((item) => {
				item.play();
			});
		}

		// this.animation.forEach((item) => {
		// 	item.play();
		// });

		this.paused = false;

		tempCamPos = false;
	},
	/**
	 * @description сбрасывает все группы анимаций.
	 * @param {Boolean} withPause устанавливает паузу для всех групп анимаций, если передано true.
	 */
	reset: function (withPause = false) {
		this.animation.forEach((item) => {
			item.reset();
		});

		if (withPause) {
			this.pause();
		}
	},
	/**
	 * @description возвращает все группы анимаций на переданный фрейм.
	 * @param {Number} frame фрейм, на который нужно вернуть все группы анимаций.
	 */
	returnToFrame: function (frame, reset = true) {
		this.animation.forEach((item) => {
			item.goToFrame(frame);
		});

		if (reset) {
			callbackProperties.resetAllFlags();
		}
	}
};

var aCnt, gCnt;
var tmpCAnimProp;
var tmpVisibility, tmpChngItem, tmpGlwItem;

// Обновление объектов анимации для kreon
const updateItems = {
	data: changeDataByWindowSize.getUpdateItemsData(),
	cvoLen: 0,
	tmpNormal: 1,
	rotationData: [],
	sceneObj: null,
	/**
	 * @description получает массив с элементами конкретного объекта.
	 * @param {String} sysName название для конкретного объекта.
	 * @returns возвращает массив со свойствами конкретного объекта.
	 */
	getItemsArray: function (sysName) {
		for (const i of this.data) {
			if (i.itemSysName === sysName) {
				return i.items;
			}
		}
	},
	/**
	 * @description ининциализирует элементы для скрытия.
	 * @param {Object} prop объект со свойствами для видимости.
	 * @param {Element} scene объект сцены.
	 */
	initFadeItems: function (prop, scene) {
		prop.names.forEach((item, index, array) => {
			this.getItemsArray(prop.itemSysName)[index] = scene.getMeshByName(array[index]);
		});
	},
	initFadeFermentsItems: function (prop, scene) {
		let fermentsNode = scene.getNodeByName(prop.names[0]);
		let ferments;

		if (fermentsNode) {
			ferments = fermentsNode.getChildren();
		}

		prop.items = ferments;
	},
	initGlowItems: function (prop, scene) {
		this.getItemsArray(prop.itemSysName)[0] = scene.getHighlightLayerByName(prop.names[0]);
	},
	getPropVisibilityNormal: function (frame, prop) {
		this.tmpNormal = ((frame - prop.fromFrame) / (prop.toFrame - prop.fromFrame));

		return (this.tmpNormal < 1 ? this.tmpNormal : 1);
	},
	getPropVisibility: function (frame, prop) {
		this.tmpNormal = this.getPropVisibilityNormal(frame, prop);

		if (this.tmpNormal > 1) {
			tmpVisibility = this.tmpNormal;
		} else {
			tmpVisibility = prop.fromVal - ((prop.fromVal - prop.toVal) * this.tmpNormal);
		}

		return tmpVisibility;
	},
	getSlideVisibility: function (frame, prop) {
		const INTERVAL = ((prop.toFrame - 0.5) - (prop.fromFrame + 0.5)) > 0.3 ? 0.5 : 0.15;

		let normal;

		if ( frame > prop.toFrame - INTERVAL ) {
			normal = ((prop.toFrame - frame) / ((prop.toFrame + INTERVAL) - prop.toFrame));
		} else if ( frame < prop.fromFrame + INTERVAL ) {
			normal = ((frame - prop.fromFrame) / ((prop.fromFrame + INTERVAL) - prop.fromFrame));
		} else {
			normal = 1;
		}

		// console.log(normal, frame.toFixed(4))

		return normal;
	},
	initSlideItems: function(prop) {
		if (prop.names) {
			for (let i = 0; i < prop.names.length; i++) {
				prop.items.push($(prop.names[i])[0]);
			}
		}
	},
	setSlideVisibility: function (prop, value) {
		if (!prop.items.length) {
			this.initSlideItems(prop);
		}

		if (prop.items) {
			for (let i = 0; i < prop.items.length; i++) {
				prop.items[i].style.opacity = value;
			}
		}
	},
	setPropVisibilityFade: function (prop, value) {
		if (prop.items) {
			for (gCnt = 0; gCnt < prop.items.length; gCnt++) {
				prop.items[gCnt].visibility = value;
			}
		}
	},
	setPropVisibilityGlow: function (prop, value) {
		prop.items[0].blurHorizontalSize = value;
		prop.items[0].blurVerticalSize = value;
	},
	updateFade: function (frame, prop, scene) {
		if (!prop.items.length) {
			this.initFadeItems(prop, scene);
		}

		this.setPropVisibilityFade(prop, this.getPropVisibility(frame, prop))
	},
	updateSlide: function(frame, prop) {
		this.setSlideVisibility(prop, this.getSlideVisibility(frame, prop));
	},
	updateFadeFerments: function (frame, prop, scene) {
		if (prop.items) {
			if (!prop.items.length) {
				this.initFadeFermentsItems(prop, scene);
			}

			this.setPropVisibilityFade(prop, this.getPropVisibility(frame, prop))
		}
	},
	updateGlow: function (frame, prop, scene, isInInterval = true) {
		if (!prop.items.length) {
			this.initGlowItems(prop, scene);
		}

		// if (frame < prop.toFrame && frame > prop.fromFrame) {
		if (isInInterval) {
			this.setPropVisibilityGlow(prop, this.getPropVisibility(frame, prop));
		}
	},
	updateGlowPulse: function (value, prop, scene) {
		if (!prop.items.length) {
			this.initGlowItems(prop, scene);
		}

		// console.log('glow-pulse ', value, prop)

		this.setPropVisibilityGlowPulse(prop, this.getGlowPulsePropVisibility(value, prop));
	},
	setPropVisibilityGlowPulse: function (prop, value) {
		prop.items[0].blurHorizontalSize = value;
		prop.items[0].blurVerticalSize = value;
	},
	getGlowPulsePropVisibility: function (value, prop) {
		let currentVal = prop.items[0].blurVerticalSize;
		let tmpNormal = (currentVal - prop.fromVal) / (prop.toVal - prop.fromVal);

		if (tmpNormal > 1) {
			tmpVisibility = tmpNormal;
		} else {
			// tmpVisibility = Math.cos(value * 4);
			tmpVisibility = Math.abs(Math.sin(value * 2) * 4);
			// tmpVisibility = currentVal - Math.abs(Math.sin(value * 2) * 2);
		}

		// console.log('glow pulse value ', tmpVisibility)

		return tmpVisibility;
	},
	/**
	 * @description обновляет свойства видимости для объектов.
	 * @param {Number} frame фрейм анимации.
	 * @param {Element} scene объект сцены.
	 */
	updateVisibility: function (frame, scene) {
		for (const i of this.data) {
			switch (true) {
				case frame >= i.fromFrame && frame < i.toFrame:
					if (i.animType === 'fade') {
						this.updateFade(frame, i, scene);
					} else if (i.animType === 'glow') {
						this.updateGlow(frame, i, scene);
					} else if (i.animType === 'fade-ferments') {
						this.updateFadeFerments(frame, i, scene);
					} else if ( i.animType === 'slide' ) {
						this.updateSlide(frame, i)
					}
					break;
				case frame < i.fromFrame:
					if (i.animType === 'fade') {
						this.updateFade(i.fromFrame, i, scene);
					} else if (i.animType === 'glow') {
						this.updateGlow(i.fromFrame, i, scene, false);
					} else if (i.animType === 'fade-ferments') {
						this.updateFadeFerments(i.fromFrame, i, scene);
					}else if ( i.animType === 'slide' ) {
						this.updateSlide(i.fromFrame, i)
					}
					break;
				case frame > i.toFrame:
					if (i.animType === 'fade') {
						this.updateFade(i.toFrame, i, scene);
					} else if (i.animType === 'glow') {
						this.updateGlow(i.toFrame, i, scene, false);
					} else if (i.animType === 'fade-ferments') {
						this.updateFadeFerments(i.toFrame, i, scene);
					} else if ( i.animType === 'slide' ) {
						this.updateSlide(i.fromFrame, i)
					}
					break;
				default:
					break;
			}
		}
	},
	itemRotation: function (itemName, value, frame, scene, interval = {x: 4, y: 4}) {
		let node = scene.getNodeByName(itemName);
		let transformNode;
		if (!scene.getTransformNodeByName(`transform_${itemName}`)) {
			transformNode = new BABYLON.TransformNode(`transform_${itemName}`);
		} else {
			transformNode = scene.getTransformNodeByName(`transform_${itemName}`);
		}

		let currentValX = transformNode.rotation.x;
		let currentValY = transformNode.rotation.y;
		let newValX = Math.sin(value * interval.x) + 1;
		let newValY = Math.sin(value * interval.y) + 1;

		node.parent = transformNode;
		transformNode.parent = scene.getNodeByName('__root__');

		if (frame === START_FRAME) {
			transformNode.rotation = new BABYLON.Vector3((currentValX + newValX) / 20, (currentValY + newValY) / 12, 0);
		} else if (frame > START_FRAME) {
			if (currentValY > 0) {
				transformNode.rotation.y = currentValY - 0.005;

				if (transformNode.rotation.y < 0) {
					transformNode.rotation.y = 0;
				}
			}
			if (currentValX > 0) {
				transformNode.rotation.x = currentValX - 0.005;

				if (transformNode.rotation.x < 0) {
					transformNode.rotation.x = 0;
				}
			}
		}
	},
	/**
	 * @description настройка моделей после их загрузки.
	 */
	initModelsJustLoaded: function (scene) {
		// for (const item in modelsJustLoaded) {
			switch (true) {

				case modelsJustLoaded[`kreonCapsule`]:

					// Выполнится когда сцена будет готова
					scene.executeWhenReady(() => {
						const kreon = scene.getAnimationGroupByName(`kreon-capsule`);

						// Удаляет загрузчик для капсулы
						buttonStart.classList.remove('disabled-link');
						pillButtonStart.classList.remove('disabled-link');
						anotherCapsuleStart.classList.remove('disabled-link');
						modelsLoader.parentElement.style.display = 'none';

						// console.log(kreon);
					});

					modelsJustLoaded[`kreonCapsule`] = false;
					break;

				case modelsJustLoaded[`kreonFerments`]:

					// Выполнится когда сцена будет готова
					scene.executeWhenReady(() => {
						const kreonFerments = scene.getAnimationGroupByName(`kreon-ferments`);

						// console.log(kreonFerments);
					});

				    modelsJustLoaded[`kreonFerments`] = false;
				    break;
			}
		// }
	},
	// /**
	//  * @description получает группу анимации по имени.
	//  * @param {Object} scene объект сцены.
	//  * @param {String} sysName название группы анимаций.
	//  * @return {Object} возвращает группу анимации с указанным именем.
	//  */
	// getAnimationGroupBySysName: function (scene, sysName) {
	// 	let result;

	// 	scene.animationGroups.forEach((item) => {
	// 		if (item.name === sysName) {
	// 			result = item;
	// 		}
	// 	});

	// 	return result;
	// }
};

var iCnt, dCnt, kCnt;
var cbTmpItem1, cbTmpItem2;

// Свойства callback для аимации
const callbackProperties = {
	data: changeDataByWindowSize.getCallbackPropertiesData(),
	dataLength: 0,
	delta: 1.5,

	getEventIndexByFrame: function (frame) {
		let currentIndex;

		this.data.forEach((item, index) => {
			if (frame > item.frame && frame < this.data[index + 1]) {
				currentIndex = index;
			}
		});

		return currentIndex;
	},
	getEventItem: function (frame) {
		return this.data[this.getEventIndexByFrame(frame)];
	},
	changeItemFlag: function (frame) {
		if (this.getEventItem(frame).doneAt === false) {
			this.getEventItem(frame).doneAt = frame
		} else {
			this.getEventItem(frame).doneAt = false;
		}
	},
	resetAllFlags: function () {
		for (dCnt = 0; dCnt < this.dataLength; dCnt++) {
			this.data[dCnt].doneAt = false;
		}
	},
	runEvent: function (frame) {
		// console.log('callback ', frame)

		for (kCnt = 0; kCnt < this.dataLength; kCnt++) {
			cbTmpItem2 = this.data[kCnt];

			if (frame > cbTmpItem2.frame && frame < cbTmpItem2.frame + this.delta && cbTmpItem2.doneAt === false) {
				cbTmpItem2.action(frame);
				cbTmpItem2.doneAt = frame;
			}

			this.resetFlag(frame, cbTmpItem2);
		}
	},
	resetFlag: function (frame, prop) {
		if (frame > prop.frame + this.delta && prop.doneAt !== false) {
			prop.doneAt = false;
		}
	}
};

callbackProperties.dataLength = callbackProperties.data.length; // Может тут что то сделать? Внести это присваивание внутрь объекта? Не совсем очивидное действие.
updateItems.cvoLen = updateItems.data.length; // Может тут что то сделать? Внести это присваивание внутрь объекта? Не совсем очивидное действие.

$(document).ready(() => {
	$('.kreon.is-loading .loader.fade').removeClass('fade');
});

// Выполняется после загрузки страницы
window.addEventListener('DOMContentLoaded', function () {
	// Позиция курсора мыши относительно ширины и высоты экрана
	let gMouseW = window.innerWidth;
	let gMouseH = window.innerHeight;
	let gMouseX = 0;
	let gMouseY = 0;

	// Обработчик изменения ширины экрана
	window.addEventListener('resize', function (evt) {
		gMouseW = evt.target.innerWidth;
		gMouseH = evt.target.innerHeight;

		engine.resize();
	});

	// Обработчик события движения мыши
	document.addEventListener('mousemove', function (evt) {
		// Отключение смещения камеры на мобильной версии
		if (window.innerWidth > 750) {
			gMouseX = 1 * evt.screenX / gMouseW - 0.5;
			gMouseY = 1 * evt.screenY / gMouseH - 0.5;
		} else {
			gMouseX = 0;
			gMouseY = 0;
		}
	});

	// Получение элемента canvas в DOM
	const canvas = document.getElementById('renderCanvas', true);

	// Загрузка движка
	const engine = new BABYLON.Engine(canvas, true);

	// Создание сцены
	const createScene = function () {
		// Создание сцены
		const scene = new BABYLON.Scene(engine);

		globalScene = scene;

		// Создание камеры
		const camera = new BABYLON.FreeCamera("Camera", new BABYLON.Vector3(0, 0, 0), scene);

		// Создание источника плейна
		const sourcePlane = new BABYLON.Plane(0, 0, 1, 0);

		// Нормалиизация источника плейна
		sourcePlane.normalize();

		// Создание материала для плейна
		const boxMat = new BABYLON.StandardMaterial("boxMat", scene);

		// Применение текстуры для материала
		boxMat.diffuseTexture = new BABYLON.Texture("textures/wide-bg.jpg", scene);

		// Параметры для плейна
		const PlaneParameters = {
			width: changeDataByWindowSize.getBgPlaneSizeData().width,
			height: changeDataByWindowSize.getBgPlaneSizeData().height,
			sourcePlane: sourcePlane,
			sideOrientation: BABYLON.Mesh.DOUBLESIDE,
			positionX: 900,
			positionY: 720,
			positionZ: -400,
			material: boxMat
		};

		// Создание плейна
		const plane = BABYLON.MeshBuilder.CreatePlane('plane', {
			width: PlaneParameters.width,
			height: PlaneParameters.height,
			sourcePlane: PlaneParameters.sourcePlane,
			sideOrientation: PlaneParameters.sideOrientation
		}, scene);

		// Задание позиции для плейна
		plane.position = new BABYLON.Vector3(PlaneParameters.positionX, PlaneParameters.positionY, PlaneParameters.positionZ);

		// Задание материала для плейна
		plane.material = PlaneParameters.material;

		// Объявление группы анимаций
		let animationGroup;

		// Флаги загрузки моделей
		let isStomachLoaded = false;
		let isFoodLoaded = false;

		// Создание свечения для желудка
		const highlight = new BABYLON.HighlightLayer("highlight", scene, {
			mainTextureFixedSize: 2048
		});

		globalHighlight = highlight

		// Enum для моделей
		const Models = {
			PATH: `models/`,
			STOMACH: `stomach.glb`,
			FOOD: `food3.glb`,
			KREON_FERMENTS: `kreon-ferments.glb`,
			PILL_FERMENTS: `pill-ferments.glb`,
			CAPSULE_FERMENTS: `capsule-ferments3.glb`,
			KREON: `kreon.glb`,
			TIMER: `timer.glb`,
			CAPSULE: 'capsule_capsule4.glb'
		};

		document.addEventListener('keydown', (evt) => {
			if (evt.code === `Space`) {
				scene.executeWhenReady(() => {
				    animationProperties.pause();
				    Timer.pause();
				});
			}
		});

		document.addEventListener('keyup', (evt) => {
			if (evt.code === `Space`) {
				scene.executeWhenReady(() => {
				    animationProperties.play();
				    Timer.play();
				});
			}
		});

		/**
		 * @description загрузка таймера.
		 */
		const getTimer = () => {
			BABYLON.SceneLoader.Append(Models.PATH, Models.TIMER, scene,
				(onSuccess) => {

					// console.log(scene.animationGroups);

					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `Timer`) {
							item.reset();
							// item.normalize();

							item.name = `timer`;
							Timer.timer = item;

							scene.getMeshByName(`Timer`).isVisible = false;
						}
					});
				},
				(OnProgress) => {

				},
				(onError) => {

				});
		};

		/**
		 * @description загрузка и настройка модели желудка.
		 */
		const getStomach = () => {
			// Добавление модели в загрузку сцены
			BABYLON.SceneLoader.Append(Models.PATH, Models.STOMACH, scene,
				(success) => {
					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `Dummy001`) {
							item.reset();
							// item.normalize();
							item.name = `stomach`;
							animationProperties.animation.push(item);
							animationGroup = item;
						}
					});

					// Создание свойства позиции для камеры
					let startCameraPos = cameraProperties[0].cameraPos;

					// Создание свойства разворота для камеры
					let startRotationPos = cameraProperties[0].rotationPos;

					// Создает камеру по умолчанию и свет по умолчанию
					scene.createDefaultCameraOrLight(true, true, false);

					// Задает параметры для камеры
					scene.activeCamera.alpha += Math.PI;
					scene.activeCamera.setPosition(new BABYLON.Vector3(startCameraPos[0], startCameraPos[1], startCameraPos[2]));
					scene.activeCamera.setTarget(new BABYLON.Vector3(startRotationPos[0], startRotationPos[1], startRotationPos[2]));

					// Создает свет по умолчанию
					scene.createDefaultLight();

					// Объявляет источники света кроме
					const helperLight = scene.lights.pop();

					// Добавляет источнии света
					scene.lights.push(helperLight);

					// Задает параметры для источников света
					helperLight.direction = new BABYLON.Vector3(1, 1, 1);
					helperLight.diffuse = new BABYLON.Color3.White();

					// Создает окружение по умолчанию
					scene.createDefaultEnvironment();

					// Объявляет ноду желудка
					const stomach = scene.getMeshByName(`Geludok`);

					// Enum для параметров материала желудка
					const WaterMaterialParameters = {
						DIFFUSE_COLOR: new BABYLON.Color3.Black(),
						BACK_FACE_CULLING: true,
						REFLECTION_TEXTURE: new BABYLON.CubeTexture(`textures/environment`, scene),
						REFLECTION_TEXTURE_LEVEL: 0.25,
						SPECULAR_POWER: 64,
						SEPARATE_CULLING_PASS: true,
						ALPHA: 0.75,
						EMISSIVE_FRESNEL_PARAMETERS: new BABYLON.FresnelParameters(),
						EMISSIVE_FRESNEL_PARAMETERS_BIAS: 0.4,
						EMISSIVE_FRESNEL_PARAMETERS_POWER: 2,
						EMISSIVE_FRESNEL_PARAMETERS_LEFT_COLOR: new BABYLON.Color3.Black(),
						EMISSIVE_FRESNEL_PARAMETERS_RIGHT_COLOR: new BABYLON.Color3.White()
					};

					// Создает экземпляр материала water
					const waterMaterial = new BABYLON.StandardMaterial(`water`, scene);

					// Задает параметры материала water
					waterMaterial.diffuseColor = WaterMaterialParameters.DIFFUSE_COLOR;
					waterMaterial.backFaceCulling = WaterMaterialParameters.BACK_FACE_CULLING;
					waterMaterial.reflectionTexture = WaterMaterialParameters.REFLECTION_TEXTURE;
					waterMaterial.reflectionTexture.level = WaterMaterialParameters.REFLECTION_TEXTURE_LEVEL;
					waterMaterial.specularPower = WaterMaterialParameters.SPECULAR_POWER;
					waterMaterial.separateCullingPass = WaterMaterialParameters.SEPARATE_CULLING_PASS;
					waterMaterial.alpha = WaterMaterialParameters.ALPHA;
					waterMaterial.emissiveFresnelParameters = WaterMaterialParameters.EMISSIVE_FRESNEL_PARAMETERS;
					waterMaterial.emissiveFresnelParameters.bias = WaterMaterialParameters.EMISSIVE_FRESNEL_PARAMETERS_BIAS;
					waterMaterial.emissiveFresnelParameters.power = WaterMaterialParameters.EMISSIVE_FRESNEL_PARAMETERS_POWER;
					waterMaterial.emissiveFresnelParameters.leftColor = WaterMaterialParameters.EMISSIVE_FRESNEL_PARAMETERS_LEFT_COLOR;
					waterMaterial.emissiveFresnelParameters.rightColor = WaterMaterialParameters.EMISSIVE_FRESNEL_PARAMETERS_RIGHT_COLOR;

					// Добавляет к желудку материал water
					stomach.material = waterMaterial;

					// Добавляет свечение для желудка
					highlight.addMesh(stomach, new BABYLON.Color3.Red());

					// Enum для параметров свечения
					const HighlightParameters = {
						INNER_GLOW: false,
						BLUR_HORIZONTAL_SIZE: GLOW_EFFECT,
						BLUR_VERTICAL_SIZE: GLOW_EFFECT
					};

					// Задает параметры для свечения желудка
					highlight.innerGlow = HighlightParameters.INNER_GLOW;
					highlight.blurHorizontalSize = HighlightParameters.BLUR_HORIZONTAL_SIZE;
					highlight.blurVerticalSize = HighlightParameters.BLUR_VERTICAL_SIZE;

					isStomachLoaded = true;
				},
				(progress) => {
				},
				(error) => {}
			);
		};

		/**
		 * @description загрузка и настройка модели с едой.
		 */
		const getFood = () => {
			// Добавление модели в загрузку сцены
			BABYLON.SceneLoader.Append(Models.PATH, Models.FOOD, scene,
				(success) => {
					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `chiken_low_`) {
							item.reset();
							// item.normalize();
							item.name = `food`;
							animationProperties.animation.push(item);
							// animationGroup = item;
						}
					});

					isFoodLoaded = true;
				},
				(progress) => {
					// Обновляет значение для полосы загрузки
					loadingProgress = parseInt(progress.loaded * 100 / progress.total, 10).toFixed(0);
				},
				(error) => {});
		};

		/**
		 * @description загрузка и настройка модели с ферментами.
		 */
		const getKreonFerments = () => {
			BABYLON.SceneLoader.Append(Models.PATH, Models.KREON_FERMENTS, scene,
				(success) => {
					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `Ferment_Pot_2_00`) {
							item.reset();
							// item.normalize();

							item.name = `kreon-ferments`;
							animationProperties.animation.push(item);

							scene.executeWhenReady(() => {
								item.pause();
								item.goToFrame(START_FRAME);
							});
						}
					});

					modelsJustLoaded.kreonFerments = true;

					// Названия нод с ферментами
					const FERMENTS_NODES = [`Ferment_Chiken`, `Ferment_Free`, `Ferment_Pot_1`, `Ferment_Pot_2`, `Ferment_Pot_3`];

					// Убирает свечение для ферментов
					FERMENTS_NODES.forEach((item) => {
						scene.getNodeByName(item).getChildMeshes().forEach((item) => {
							highlight.addExcludedMesh(item);
							item.visibility = 0;
						});
					});

				},
				(progress) => {
				},
				(error) => {});
		};

		/**
		 * @description загрузка и настройка модели с ферментами.
		 */
		const getPillFerments = () => {
			BABYLON.SceneLoader.Append(Models.PATH, Models.PILL_FERMENTS, scene,
				(success) => {
					// Названия нод с ферментами
					const FERMENTS_NODES = [`Pill_Ferment_Chiken`, `Pill_Ferment_Chiken_Free`, `Pill_Ferment_Pot2`, `Pill_Ferment_Pot3`];

					// Убирает свечение для ферментов
					FERMENTS_NODES.forEach((item) => {
						scene.getNodeByName(item).getChildMeshes().forEach((item) => {
							highlight.addExcludedMesh(item);
							item.visibility = 0;
						});
					});

					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `Pill_Ferment_Pot2_00`) {
							item.reset();
							// item.normalize();

							item.name = `pill-ferments`;
							animationProperties.animation.push(item);

							scene.executeWhenReady(() => {
								item.pause();
								item.goToFrame(START_FRAME);
							});
						}
					});

					modelsJustLoaded.kreonFerments = true;

				},
				(progress) => {
				},
				(error) => {});
		};

		const getCapsuleFerments = () => {
			BABYLON.SceneLoader.Append(Models.PATH, Models.CAPSULE_FERMENTS, scene,
				(success) => {
					// Названия нод с ферментами
					const FERMENTS_NODES = [`Capsule_Ferment_Chiken`, `Capsule_Ferment_Pot1`, `Capsule_Ferment_Pot2`, `Capsule_Ferment_Pot3`];

					// Убирает свечение для ферментов
					FERMENTS_NODES.forEach((item) => {
						scene.getNodeByName(item).getChildMeshes().forEach((item) => {
							highlight.addExcludedMesh(item);
							item.visibility = 0;
						});
					});

					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `Capsule_Ferment_Pot2_00`) {
							item.reset();
							// item.normalize();

							item.name = `capsule-ferments`;
							animationProperties.animation.push(item);

							scene.executeWhenReady(() => {
								item.pause();
								item.goToFrame(START_FRAME);
							});
						}
					});

					modelsJustLoaded.kreonFerments = true;

				},
				(progress) => {
				},
				(error) => {});
		};

		/**
		 * @description загрузка и настройка модели с капсулой.
		 */
		const getKreon = () => {
			BABYLON.SceneLoader.Append(Models.PATH, Models.KREON, scene,
				(success) => {
					// Названия нод для капсулы
					const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

					// Убирает свечение для капсулы
					KREON_NODES.forEach((item) => {
						scene.getNodeByName(item).getChildMeshes().forEach((item) => {
							highlight.addExcludedMesh(item);
							item.isVisible = false;
						});
					});

					scene.animationGroups.forEach((item) => {
						// if (item.targetedAnimations[0].target.id === `Minimicrokapsula`) {
						if (item.targetedAnimations[0].target.id === `Kapsula` && item.targetedAnimations.length === 3250) {
							item.reset();
							// item.normalize();

							item.name = `kreon-capsule`;
							animationProperties.animation.push(item);

							scene.executeWhenReady(() => {
								item.pause();
								item.goToFrame(START_FRAME);

								// Добавляет свойства для видимости моделей
								let itemsDesktop = [
									{
										itemSysName: 'pill',
										animType: 'fade',
										fromFrame: 105.5,
										toFrame: 106,
										fromVal: 1,
										toVal: 0,
										names: ['KapsulaUp002', 'KapsulaDoun002'],
										items: []
									},
									{
										itemSysName: 'pill2',
										animType: 'fade',
										fromFrame: 212,
										toFrame: 212.6,
										fromVal: 1,
										toVal: 0,
										names: ['KapsulaUp003', 'KapsulaDoun003'],
										items: []
									},
									{
										itemSysName: 'fermentGroup1',
										animType: 'fade-ferments',
										fromFrame: 113, // 14
										toFrame: 114, // 15
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Pot_3'],
										items: []
									},
									{
										itemSysName: 'fermentGroup2',
										animType: 'fade-ferments',
										fromFrame: 121.5, // 16
										toFrame: 122.5, // 17
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Pot_2'],
										items: []
									},
									{
										itemSysName: 'fermentGroup3',
										animType: 'fade-ferments',
										fromFrame: 131.5, // 20
										toFrame: 132.5, // 21
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Chiken'],
										items: []
									},
									{
										itemSysName: 'fermentGroup4',
										animType: 'fade-ferments',
										fromFrame: 135.5, // 24
										toFrame: 136.5, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Pot_1'],
										items: []
									},
									{
										itemSysName: 'fermentGroup5',
										animType: 'fade-ferments',
										fromFrame: 134.5, // 24
										toFrame: 135.5, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Free'],
										items: []
									},
									{
										itemSysName: 'fermentGroup1',
										animType: 'fade-ferments',
										fromFrame: 234, // 14
										toFrame: 235, // 15
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Pot3'],
										items: []
									},
									{
										itemSysName: 'fermentGroup2',
										animType: 'fade-ferments',
										fromFrame: 234, // 16
										toFrame: 235, // 17
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Pot2'],
										items: []
									},
									{
										itemSysName: 'fermentGroup3',
										animType: 'fade-ferments',
										fromFrame: 239, // 20
										toFrame: 240, // 21
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Chiken'],
										items: []
									},
									// {
									// 	itemSysName: 'fermentGroup4',
									// 	animType: 'fade-ferments',
									// 	fromFrame: 234, // 24
									// 	toFrame: 235, // 25
									// 	fromVal: 0,
									// 	toVal: 0.99,
									// 	names: ['Capsule_Ferment_Pot1'],
									// 	items: []
									// },
									{
										itemSysName: 'fermentGroup1',
										animType: 'fade-ferments',
										fromFrame: 26, // 14
										toFrame: 27, // 15
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Pot3'],
										items: []
									}, {
										itemSysName: 'fermentGroup2',
										animType: 'fade-ferments',
										fromFrame: 27, // 16
										toFrame: 28, // 17
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Pot2'],
										items: []
									}, {
										itemSysName: 'fermentGroup3',
										animType: 'fade-ferments',
										fromFrame: 35.5, // 20
										toFrame: 37, // 21
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Chiken'],
										items: []
									}, {
										itemSysName: 'fermentGroup5',
										animType: 'fade-ferments',
										fromFrame: 38, // 24
										toFrame: 39, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Chiken_Free'],
										items: []
									}
								];

								let itemsMobile = [
									{
										itemSysName: 'pill',
										animType: 'fade',
										// fromFrame: 118,
										// toFrame: 119.5,
										fromFrame: 108.5,
										toFrame: 110,
										fromVal: 1,
										toVal: 0,
										names: ['KapsulaUp002', 'KapsulaDoun002'],
										items: []
									},
									{
										itemSysName: 'pill2',
										animType: 'fade',
										// fromFrame: 118,
										// toFrame: 119.5,
										fromFrame: 208.5,
										toFrame: 213,
										fromVal: 1,
										toVal: 0,
										names: ['KapsulaUp003', 'KapsulaDoun003'],
										items: []
									},
									{
										itemSysName: 'fermentGroup1',
										animType: 'fade-ferments',
										fromFrame: 139, // 14
										toFrame: 140, // 15
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Pot_3'],
										items: []
									},
									{
										itemSysName: 'fermentGroup2',
										animType: 'fade-ferments',
										fromFrame: 141, // 16
										toFrame: 142, // 17
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Pot_2'],
										items: []
									},
									{
										itemSysName: 'fermentGroup3',
										animType: 'fade-ferments',
										fromFrame: 148, // 20
										toFrame: 149, // 21
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Chiken'],
										items: []
									},
									{
										itemSysName: 'fermentGroup4',
										animType: 'fade-ferments',
										fromFrame: 159, // 24
										toFrame: 160, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Pot_1'],
										items: []
									},
									{
										itemSysName: 'fermentGroup5',
										animType: 'fade-ferments',
										fromFrame: 158, // 24
										toFrame: 159, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Ferment_Free'],
										items: []
									},
									{
										itemSysName: 'fermentGroup1',
										animType: 'fade-ferments',
										fromFrame: 231, // 14
										toFrame: 232, // 15
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Pot3'],
										items: []
									},
									{
										itemSysName: 'fermentGroup2',
										animType: 'fade-ferments',
										fromFrame: 240, // 16
										toFrame: 241, // 17
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Pot2'],
										items: []
									},
									{
										itemSysName: 'fermentGroup3',
										animType: 'fade-ferments',
										fromFrame: 244, // 20
										toFrame: 245, // 21
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Chiken'],
										items: []
									},
									// {
									// 	itemSysName: 'fermentGroup4',
									// 	animType: 'fade-ferments',
									// 	fromFrame: 245, // 24
									// 	toFrame: 246, // 25
									// 	fromVal: 0,
									// 	toVal: 0.99,
									// 	names: ['Capsule_Ferment_Pot1'],
									// 	items: []
									// },
									{
										itemSysName: 'fermentGroup5',
										animType: 'fade-ferments',
										fromFrame: 258, // 24
										toFrame: 259, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Capsule_Ferment_Free'],
										items: []
									},
									{
										itemSysName: 'fermentGroup1',
										animType: 'fade-ferments',
										fromFrame: 40, // 14
										toFrame: 41, // 15
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Pot3'],
										items: []
									}, {
										itemSysName: 'fermentGroup2',
										animType: 'fade-ferments',
										fromFrame: 41, // 16
										toFrame: 42, // 17
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Pot2'],
										items: []
									}, {
										itemSysName: 'fermentGroup3',
										animType: 'fade-ferments',
										fromFrame: 60, // 20
										toFrame: 61, // 21
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Chiken'],
										items: []
									}, {
										itemSysName: 'fermentGroup5',
										animType: 'fade-ferments',
										fromFrame: 50, // 24
										toFrame: 51, // 25
										fromVal: 0,
										toVal: 0.99,
										names: ['Pill_Ferment_Chiken_Free'],
										items: []
									}
								];

								if (!isMobileSize) {
									itemsDesktop.forEach(arrItem => {
										updateItems.data.push(arrItem);
									});
								} else {
									itemsMobile.forEach(arrItem => {
										updateItems.data.push(arrItem);
									});
								}
							});
						}
					});

					// Флаг загрузки модели
					modelsJustLoaded.kreonCapsule = true;

					// Задает более яркий белый цвет для микросфер
					scene.materials.forEach((item) => {
						if (item.name === 'default' || item.name === '__GLTFLoader._default') {
							item.emissiveColor = new BABYLON.Color3.Gray();
						}
					});
				},
				(progress) => {
					modelsLoader.style.width = `${parseInt(progress.loaded * 100 / progress.total, 10).toFixed(0)}%`;
				},
				(error) => {});
		};

		const getPill = () => {
			BABYLON.SceneLoader.Append("models/", "pill_pill.glb", scene,
				(success) => {

					const PILL_NODES = [`Object001`, `Cylinder258`];

					PILL_NODES.forEach((item) => {
						globalScene.getMeshByName(item).isVisible = false;
					});

					scene.animationGroups.forEach((item) => {
						if (item.targetedAnimations[0].target.id === `Cylinder258`) {
							item.reset();
							// item.normalize();
							item.name = `pill`;
							animationProperties.animation.push(item);

							scene.executeWhenReady(() => {
								item.pause();
								item.goToFrame(START_FRAME);
							});
						}
					});

					// scene.getMeshByName('Cylinder257').isVisible = false;
					// scene.getMeshByName('Ferment_Chiken_Low_00').isVisible = false;

					// scene.executeWhenReady(() => {
					// 	scene.getMeshByName('Cylinder257').isVisible = true;
					// 	scene.getMeshByName('Ferment_Chiken_Low_00').isVisible = true;
					// });

					// console.log('Tabletka', scene);
				},
				(progress) => {
				},
				(error) => {
					// console.log(error);
				});
		};

		const getCapsule = () => {
			BABYLON.SceneLoader.Append(Models.PATH, Models.CAPSULE, scene,
				(success) => {
					// Названия нод для капсулы
					const CAPSULE_NODES = [`Kapsula2`, `Mikrokapsula`];

					// Убирает свечение для капсулы
					CAPSULE_NODES.forEach((item) => {
						scene.getNodeByName(item).getChildMeshes().forEach((mesh) => {
							highlight.addExcludedMesh(mesh);
							mesh.isVisible = false;
						});
					});

					console.log('capsule!')

					scene.animationGroups.forEach((item) => {
						// if (item.targetedAnimations[0].target.id === "Kapsula" && item.targetedAnimations.length === 666) {
						if (item.targetedAnimations[0].target.id === "Kapsula2") {
							item.reset();
							// item.normalize();

							item.name = `another-capsule`;
							animationProperties.animation.push(item);

							scene.executeWhenReady(() => {
								item.pause();
								item.goToFrame(START_FRAME);
							});
						}
					});
				},
				(progress) => {
					// modelsLoader.style.width = `${parseInt(progress.loaded * 100 / progress.total, 10).toFixed(0)}%`;
				},
				(error) => {});
		};

		getTimer();
		getStomach();
		getFood();
		// getFerments();

		globalEngine = engine;
		engine.renderEvenInBackground = true;
		console.log(engine, ' engine')

		// Тестовые кнопки управления для камеры
		$('.test-buttons .camera').click(event => {
			tempCamPos = true;

			let button = event.target;
			let camVab = scene.cameras[0];
			let x = camVab.target.x;
			let y = camVab.target.y;
			let z = camVab.target.z;

			switch (true) {
				case ($(button).hasClass('x-up')):
					x += 10;
					break;
				case ($(button).hasClass('x-down')):
					x -= 10;
					break;
				case ($(button).hasClass('y-up')):
					y += 10;
					break;
				case ($(button).hasClass('y-down')):
					y -= 10;
					break;
				case ($(button).hasClass('z-up')):
					z += 10;
					break;
				case ($(button).hasClass('z-down')):
					z -= 10;
					break;
			}

			scene.activeCamera.setPosition(new BABYLON.Vector3(x, y, z + 200));
			scene.activeCamera.setTarget(new BABYLON.Vector3(x, y, z));

			console.log('raw ', x, y, z);
			console.log('modifed ', x + (gMouseX * 150 * 0.75) / 2, y + (gMouseY * 200 * 0.75) / 2, z + 200);
		});

		// Тестовые кнопки вернуться к фрейму
		document.querySelector('.return-to-frame').addEventListener('click', () => {
			hideSlides();
			animationProperties.play();
			animationProperties.returnToFrame(START_FRAME, false);
			Timer.play();
			Timer.returnToFrame(START_FRAME);
		});

		isMySceneLoading = true;

		// Обработчик нажатия на левую кнопку в мобильной версии
		const leftButtonClickHandler = () => {
			let currentFrame = Timer.getFrame();
			let currentTimelineIndex = timeline.getTimelineIndexByFrame(currentFrame);
			let previousTimelineIndex = timeline.data[currentTimelineIndex].id > 0 ? currentTimelineIndex - 1 : null;

			console.log(currentFrame, ' currentFrame')
			console.log(currentTimelineIndex, ' currentTimelineIndex')
			console.log(previousTimelineIndex, ' previousTimelineIndex')
			console.log(timeline.data[currentTimelineIndex], ' current prop')
			console.log(timeline.data[previousTimelineIndex], ' prev prop')

			if (currentTimelineIndex > 0 && isStartButtonPressed && previousTimelineIndex !== null && timeline.data[currentTimelineIndex].id > 0) {
				// animationProperties.returnToFrame(timeline.getAnimationpropertiesFrame(timeline.data[previousTimelineIndex].id), currentFrame);
				globalScene.executeWhenReady(() => {
					if (currentTimelineIndex == 1) {
						callbackProperties.data[0].doneAt = START_FRAME;
						animationProperties.returnToFrame(timeline.data[previousTimelineIndex].animStart, false);
						Timer.returnToFrame(timeline.data[previousTimelineIndex].start);
						Timer.play();
						animationProperties.play();
						console.log('play')
					} else {
						callbackProperties.resetAllFlags();
						animationProperties.returnToFrame(timeline.data[previousTimelineIndex].animStart);
						Timer.returnToFrame(timeline.data[previousTimelineIndex].start);
					}
				});

				if(timeline.data[currentTimelineIndex].id == timeline.getLastIndex() || timeline.data[currentTimelineIndex].id == 4 && Timer.getFrame() > 200) {
					globalScene.executeWhenReady(() => {
						Timer.play();
						animationProperties.play();
						filterGradient.style.display = 'block';
						repeatButtonMobile.style.display = 'none';
						allowTimer = true;
						document.querySelector('.slider').style.pointerEvents = 'none';
						document.querySelector('.kreon-capsule.step7').classList.remove('scroll');
						document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'none';
						startPillButtonMobile.style.pointerEvents = 'none';
						startPillButtonMobile.style.display = 'none';
						startKreonButtonMobile.style.pointerEvents = 'none';
						startKreonButtonMobile.style.display = 'none';
						if (document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
							document.querySelector('.slider-footer').classList.remove('at-last-slide');
						}
					});
				}
			} else if (isStartButtonPressed && timeline.data[currentTimelineIndex].id == 0) {
				globalScene.executeWhenReady(() => {
					if (currentTimelineIndex == 0) {
						callbackProperties.data[0].doneAt = START_FRAME;
						animationProperties.returnToFrame(timeline.data[currentTimelineIndex].animStart, false);
						Timer.returnToFrame(timeline.data[currentTimelineIndex].start);
						Timer.play();
						animationProperties.play();
						console.log('play')
					} else {
						callbackProperties.resetAllFlags();
						animationProperties.returnToFrame(timeline.data[currentTimelineIndex].animStart);
						Timer.returnToFrame(timeline.data[currentTimelineIndex].start);
					}
				});
			}
		};

		// Обработчик нажатия на правую кнопку в мобильной версии
		const rightButtonClickHanlder = () => {
			let currentFrame = Timer.getFrame();
			let currentTimelineIndex = timeline.getTimelineIndexByFrame(currentFrame);
			let nextTimelineIndex = timeline.data[currentTimelineIndex].id < timeline.getLastIndex() ? currentTimelineIndex + 1 : null;

			console.log(currentFrame, ' currentFrame')
			console.log(currentTimelineIndex, ' currentTimelineIndex')
			console.log(nextTimelineIndex, ' nextTimelineIndex')
			console.log(timeline.data[currentTimelineIndex], ' current prop')
			console.log(timeline.data[nextTimelineIndex], ' next prop')

			if (nextTimelineIndex !== null && isStartButtonPressed) {
				// animationProperties.returnToFrame(timeline.getTimeLineElementByIndex(currentTimelineIndex - 1).start);
				callbackProperties.resetAllFlags();
				animationProperties.returnToFrame(timeline.data[nextTimelineIndex].animStart);
				Timer.returnToFrame(timeline.data[nextTimelineIndex].start);
			}

			// console.log(currentFrame, currentTimelineIndex);
		};

		leftButton.addEventListener('click', leftButtonClickHandler);
		rightButton.addEventListener('click', rightButtonClickHanlder);

		// Начальные и конечные фреймы для анимации мобильной версии
		const timelineItemsData = [
			{
				id: 0,
				start: START_FRAME,
				end: 1.2
			},
			{
				id: 1,
				start: 1.2,
				end: 3
			},
			{
				id: 2,
				start: 3,
				end: 9
			},
			{
				id: 3,
				start: 9,
				end: 14.5
			},
			{
				id: 4,
				start: 14.5,
				end: 18
			},
			{
				id: 5,
				start: 18,
				end: 20
			},
			{
				id: 6,
				start: 20,
				end: 26
			},
			{
				id: 7,
				start: 26,
				end: 28
			},
			{
				id: 0,
				start: 100.15,
				end: 101.2
			},
			{
				id: 1,
				start: 101.2,
				end: 103
			},
			{
				id: 2,
				start: 103,
				end: 109
			},
			{
				id: 3,
				start: 109,
				end: 114.5
			},
			{
				id: 4,
				start: 114.5,
				end: 118
			},
			{
				id: 5,
				start: 118,
				end: 120
			},
			{
				id: 6,
				start: 120,
				end: 126
			},
			{
				id: 7,
				start: 126,
				end: 128
			}
		];

		/**
		 * @description получает текущий индекс по фрейму.
		 * @param {Number} frame текущий фрейм.
		 * @returns {Number} возвращает индекс по переданному фрейму.
		 */
		const getCurrentTimelineItem = (frame) => {
			let currentIndex;

			timelineItemsData.forEach((item, index) => {
				if (frame >= item.start && frame < item.end) {
					currentIndex = item.id;
				} else if (frame > timelineItemsData[(timelineItemsData.length / 2) - 1].end && frame < 99) {
					currentIndex = (timelineItemsData.length / 2) - 1;
					filterGradient.style.display = 'block';
					render.classList.remove('render-mobile');
				}
			});

			return currentIndex;
		};

		/**
		 * @description заполнение временной шкалы от фрейма.
		 * @param {Number} frame текущий фрейм.
		 */
		// const timeline = (frame) => {
		// 	const timelineContainer = document.querySelectorAll('.timeline-item');
		//
		// 	const currentTimelineIndex = getCurrentTimelineItem(frame);
		//
		// 	const LAST = 7;
		//
		// 	console.log(currentTimelineIndex)
		//
		// 	if (scene.isReady() && frame >= timelineItemsData[currentTimelineIndex].start && frame < timelineItemsData[currentTimelineIndex].end) {
		// 		// let percent = (((frame - timelineItemsData[currentTimelineIndex].start) / (timelineItemsData[currentTimelineIndex].end - timelineItemsData[currentTimelineIndex].start)) * 100);
		// 		let percent = ((timelineItemsData[currentTimelineIndex].end - frame) / (timelineItemsData[currentTimelineIndex].end - timelineItemsData[currentTimelineIndex].start)) * 100;
		//
		// 		timelineContainer[currentTimelineIndex].querySelector('.timeline-item-active').style.width = `${percent > 5 ? percent.toFixed(0) : 0}%`;
		// 	}
		// 	if (currentTimelineIndex > 0) {
		// 		if (timelineContainer[currentTimelineIndex - 1].querySelector('.timeline-item-active').style.width !== '100%' && frame > timelineItemsData[currentTimelineIndex - 1].end && frame > timelineItemsData[timelineItemsData.length / 2].start ) {
		// 			timelineContainer[currentTimelineIndex - 1].querySelector('.timeline-item-active').style.width = '100%';
		// 		}
		// 	}
		//
		// 	const setTimelinePercent = () => {
		//
		// 	}
		//
		// 	if (isCloseButtonPressed) {
		// 		clearTimeline();
		// 	}
		// };

		const timeline = {
			data: [
				{
					id: 0,
					start: START_FRAME,
					end: 10,
					animStart: START_FRAME,
				},
				{
					id: 1,
					start: 11,
					end: 20,
					animStart: 1.2,
				},
				{
					id: 2,
					start: 21,
					end: 32.5,
					animStart: 4.2,
				},
				{
					id: 3,
					start: 33.5,
					end: 42,
					animStart: 7.2,
				},
				{
					id: 4,
					start: 43,
					end: 49,
					animStart: 12.7,
				},
				{
					id: 5,
					start: 50,
					end: 51,
					animStart: 15.7,
				},
				{
					id: 6,
					start: 52,
					end: 63,
					animStart: 15.8,
				},
				{
					id: 7,
					start: 64,
					end: 66.1,
					animStart: 17.7,
				},
				{
					id: 0,
					start: 101.2,
					end: 110,
					animStart: 1.2,
				},
				{
					id: 1,
					start: 111,
					end: 120,
					animStart: 4.2,
				},
				{
					id: 2,
					start: 121,
					end: 130.5,
					animStart: 7.2,
				},
				{
					id: 3,
					start: 131.5,
					end: 140,
					animStart: 12.7,
				},
				{
					id: 4,
					start: 141,
					end: 149,
					animStart: 15.7,
				},
				{
					id: 5,
					start: 150,
					end: 152,
					animStart: 15.8,
				},
				{
					id: 6,
					start: 153,
					end: 163,
					animStart: 17.7,
				},
				{
					id: 7,
					start: 164,
					end: 166.1,
					animStart: 17.7,
				},
				{
					id: 0,
					start: 201.2,
					end: 213,
					animStart: 1.2,
				},
				{
					id: 1,
					start: 214,
					end: 223,
					animStart: 4.2,
				},
				{
					id: 2,
					start: 224,
					end: 241.5,
					animStart: 7.2,
				},
				{
					id: 3,
					start: 241.5,
					end: 250,
					animStart: 17.2,
				},
				{
					id: 4,
					start: 251,
					end: 253.8,
					animStart: 26.7,
				},
				// {
				// 	id: 5,
				// 	start: 250,
				// 	end: 252,
				// 	animStart: 15.8,
				// },
				// {
				// 	id: 6,
				// 	start: 253,
				// 	end: 263,
				// 	animStart: 17.7,
				// },
				// {
				// 	id: 6,
				// 	start: 264,
				// 	end: 266.1,
				// 	animStart: 17.7,
				// }
			],
			interval: {
				min: 0,
				max: 100
			},
			updateInterval: function (frame) {
				switch (true) {
					case frame >= 0 && frame <= 100:
						this.interval.min = 0;
						this.interval.max = 100;
						break;
					case frame >= 100 && frame <= 200:
						this.interval.min = 100;
						this.interval.max = 200;
						break;
					case frame >= 200 && frame <= 300:
						this.interval.min = 200;
						this.interval.max = 300;
						break;
				}
			},
			isInInterval: function (frame) {
				return frame > this.interval.min && frame < this.interval.max;
			},
			getTimelineIndexByFrame: function(frame) {
				for (let i = 0; i < this.data.length; i++) {
					if (frame >= this.data[i].start && frame <= this.data[i].end) {
						return i
					}
				}
			},
			getTimelinePropByFrame: function(frame) {
				return this.data[this.getTimelineIndexByFrame(frame)]
			},
			getTimeLineElementByFrame: function(frame) {
				return $('.timeline-item .timeline-item-active')[this.getTimelinePropByFrame(frame).id];
			},
			getTimeLineElementByIndex: function(index) {
				return $('.timeline-item .timeline-item-active')[index];
			},
			timelinePercent: {
				setPercent: function (item, value) {
					if (value > 0 && value < 100) {
						$(item).css('width', `${100 - value.toFixed(0)}%`);
					}
				},
				setMin: function(item) {
					$(item).css('width', `0%`);
				},
				setMax: function(item) {
					$(item).css('width', `100%`);
				}
			},
			getPercents: function(frame, prop) {
				// return ((prop.end - frame) / (prop.end - prop.start)) * 100
				return ((frame - prop.end) / (prop.end - prop.start)) * -100
			},
			getLastIndex: function () {
				let max = 0;

				this.data.forEach(item => {
					if (item.id > max) {
						max = item.id;
					}
				});

				return max;
			},
			updateItems: function(frame) {
				this.updateInterval(frame);

				for (const item of this.data) {
					switch (true) {
						case frame > item.start && frame < item.end:
							this.timelinePercent.setPercent(this.getTimeLineElementByIndex(item.id), this.getPercents(frame, item));
							break;
						case frame < item.start && this.isInInterval(item.start):
							this.timelinePercent.setMin(this.getTimeLineElementByIndex(item.id));
							break;
						case frame > item.end:
							this.timelinePercent.setMax(this.getTimeLineElementByIndex(item.id));
							// this.timelinePercent.setMax(this.getTimeLineElementByIndex(item.id > 0 ? item.id - 1 : 0));
							break;
						default:
							break;
					}
				}
			},
			// getAnimationpropertiesFrame: function(id, frame) {
			// 	let time = 0;
			//
			//
			// 	this.data.forEach((item, index) => {
			// 		if (item.id <= id) {
			// 			time += item.end - item.start;
			// 		}
			// 	});
			//
			// 	return START_FRAME + time;
			// }
		};

		const repeatSlidesClickHandler = () => {
			if (animationSelected == 0 || animationSelected == 2) {
				animationSelected = 1;
				showKreon();
				let startFrame = timeline.data[8];

				Timer.returnToFrame(startFrame.start)
				animationProperties.returnToFrame(startFrame.animStart)
			} else if (animationSelected == 1) {
				animationSelected = 0;
				showPill();
				let startFrame = timeline.data[0];

				Timer.returnToFrame(startFrame.start)
				animationProperties.returnToFrame(startFrame.animStart, false)
				callbackProperties.data[0].doneAt = START_FRAME;
			}

			updateItems.getItemsArray('stomachOff2')[0].isEnabled = true;

			globalScene.executeWhenReady(() => {
				Timer.play();
				animationProperties.play();
				filterGradient.style.display = 'block';
				repeatButtonMobile.style.display = 'none';
				allowTimer = true;
				document.querySelector('.slider').style.pointerEvents = 'none';
				document.querySelector('.kreon-capsule.step7').classList.remove('scroll');
				document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'none';
				document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'none';
				startPillButtonMobile.style.pointerEvents = 'none';
				startPillButtonMobile.style.display = 'none';
				startKreonButtonMobile.style.pointerEvents = 'none';
				startKreonButtonMobile.style.display = 'none';
				if (document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
					document.querySelector('.slider-footer').classList.remove('at-last-slide');
				}
			});

		};

		startKreonButtonMobile.addEventListener('click', repeatSlidesClickHandler);
		startPillButtonMobile.addEventListener('click', repeatSlidesClickHandler);

		// Выполнение перед рендером сцены
		scene.registerBeforeRender(() => {
			engine.hideLoadingUI();

			if (scene.getAnimationGroupByName(`food`)) {
				// console.log(scene.getAnimationGroupByName(`food`).animatables[0]._paused);
				// console.log(scene.getAnimationGroupByName(`food`).animatables[0].masterFrame);
				// console.log(animationProperties.animation);
			}

			// console.log(Timer.getFrame());

			if (scene.getAnimationGroupByName(`timer`)) {
				document.querySelector(`.time`).textContent = scene.getAnimationGroupByName(`timer`).animatables[0].masterFrame.toFixed(2);
			}

			updateItems.initModelsJustLoaded(scene);

			if (scene.isReady() && isMySceneLoading) {
				loadingProgress = 100;
				$('.loader-progress-wrapper .loader-progress').css('width', `${loadingProgress}%`);

				setTimeout(() => {
					$('body > .kreon').removeClass('is-loading');
				}, 500);

				//подключение второстепенных моделей
				getPill();
				getCapsule();
				getKreon();
				getKreonFerments();
				getPillFerments();
				getCapsuleFerments();

				isMySceneLoading = false;

				console.log(globalScene)
				console.log(globalScene)
			}

			let tempLoadProgressUnit = scene.getWaitingItemsCount();

			if (loadingProgress < 100) {
				$('.loader-progress-wrapper .loader-progress').css('width', `${loadingProgress}%`)
			}

			if (animationGroup && !tempCamPos && loadingProgress >= 100) {
				// Фрейм для остановки свечения
				const GLOWING_STOP_FRAME = 4;

				// Объявлене текущего фрейма
				// let currentFrame = animationGroup.animatables[0].masterFrame;

				let currentFrame = Timer.getFrame();
				let isInBackground = engine._windowIsBackground;

				//Обработка синхронизации анимации моделей
				let stomachFrame = scene.getAnimationGroupByName('stomach').animatables[0].masterFrame;
				// let foodFrame = scene.getAnimationGroupByName(`food`).animatables[0].masterFrame;

				animationProperties.animation.forEach(item => {
					if (item.animatables[0].masterFrame !== stomachFrame && item.name !== `food`) {
						item.goToFrame(stomachFrame);
					}
				});

				// console.log(currentFrame)
				// console.log(engine._windowIsBackground);

				if (scene.getAnimationGroupByName(`food`)) {
					if (scene.getAnimationGroupByName(`food`).animatables[0].masterFrame !== stomachFrame + MAX_FOOD_FRAME * animationSelected / 3) {
						scene.getAnimationGroupByName(`food`).goToFrame(stomachFrame + MAX_FOOD_FRAME * animationSelected / 3);
					}
				}

				// // Возвращает еду для креон
				// if (currentFrame >= 100 + START_FRAME && !scene.getAnimationGroupByName(`food`).animatables[0]._paused) {
				// 	// globalScene.getAnimationGroupByName(`food`).reset();
				// 	globalScene.getAnimationGroupByName(`food`).goToFrame(MAX_FOOD_FRAME / 3 + START_FRAME + currentFrame - 100 - START_FRAME);
				// }

				// Объявление координат камеры
				let newCamCoords = cameraMoving.getCameraPos(currentFrame);

				// Тестовые кнопки обновление счетчика фреймов
				$('.test-buttons .frames-counter').text(animationProperties.animation[0].animatables[0].masterFrame.toFixed(2));

				// Задание свойства позиции для камеры
				scene.activeCamera.setPosition(new BABYLON.Vector3(newCamCoords[0] + gMouseX * 150, newCamCoords[1] + gMouseY * 200, newCamCoords[2]));

				// Задание свойства таргета для камеры
				scene.activeCamera.setTarget(new BABYLON.Vector3(newCamCoords[0] + gMouseX * 150 * 0.2, newCamCoords[1] + gMouseY * 200 * 0.2, newCamCoords[2] - 1000));

				// console.log(newCamCoords[0] + gMouseX * 150, newCamCoords[1] + gMouseY * 200, newCamCoords[2]);

				// Изменение счетчика для свечения желудка
				if (isItemsRotate) {
					hlCounter += HL_DELTA;
				}

				if (loadingProgress === 100 && isMobileSize && isStartButtonPressed) {
					// Вызов изменения временной шкалы
					// timeline(currentFrame);
					timeline.updateItems(currentFrame);
				}

				// Обновление видимости объектов
				updateItems.updateVisibility(currentFrame, scene);

				// Вызов метода для callback свойств камеры
				callbackProperties.runEvent(currentFrame);

				if (currentFrame > intervals[animationSelected].end && !isMobileSize && !isInBackground) {
					console.log(Timer.getFrame(), ' focused from beforeRender')
					callbackProperties.resetAllFlags();
					globalScene.executeWhenReady(() => {
						Timer.returnToFrame(intervals[animationSelected].end);
						animationProperties.returnToFrame(intervals[animationSelected].animEnd);
						animationProperties.pause();
					})
				}

				// if (currentFrame > intervals[animationSelected].start && currentFrame < intervals[animationSelected].end && !isMobileSize && isFocused && isInBackground) {
				// 	console.log(Timer.getFrame(), ' blur')
				// 	Timer.pause();
				// 	animationProperties.pause();
				// 	setTimeout(() => {
				// 		isFocused = false;
				// 	}, 50);
				// 	console.log(tabVisibility().isHidden(), ' blur');
				// }
				//
				// if (currentFrame > intervals[animationSelected].start && currentFrame < intervals[animationSelected].end && !isMobileSize && !isFocused && !isInBackground) {
				// 	console.log(Timer.getFrame(), ' focused')
				// 	globalScene.executeWhenReady(() => {
				// 		Timer.play();
				// 		if (allowPlay) {
				// 			animationProperties.play();
				// 			console.log('play')
				// 		}
				// 		isFocused = true;
				// 		console.log(tabVisibility().isHidden(), ' focus');
				// 	});
				// }

				// if (!allowPlay) {
				// 	foodPauseFrame.frame = stomachFrame;
				// 	foodPauseFrame.allowWrite = false;
				// }
				//
				// if (allowPlay && !foodPauseFrame.allowWrite) {
				// 	foodPauseFrame.allowWrite = true;
				// }

				// Обновление свечения желудка при фрейме
				if (currentFrame < GLOWING_STOP_FRAME) {
					updateItems.data.forEach((item) => {
						if (item.itemSysName === 'stomachOn') {
							updateItems.initGlowItems(item, scene);
							// updateItems.updateGlowPulse(currentFrame, item, scene);
							updateItems.updateGlowPulse(hlCounter, item, scene);
						}
					});
				}

				// Переключение слайдера через 3с по таймеру
				// if (isMobileSize && scene.isReady() && isMobileSlider) {
				// if (isMobileSize && isMobileSlider) {
				if (isMobileSize && loadingProgress >= 100 && isMobileSlider) {
					setTimeout(() => {
						document.querySelector('.step1 .slick-next').click();
					}, 5000);

					isMobileSlider = false;
				}

				// Вызов методов для вращения объектов
				if (isStomachLoaded && isFoodLoaded) {
					updateItems.itemRotation('chiken_low_', hlCounter, currentFrame, scene, {
						x: 2,
						y: 3
					});
					updateItems.itemRotation('Potato_1', hlCounter, currentFrame, scene, {
						x: 2.5,
						y: 4
					});
					updateItems.itemRotation('Potato_2', hlCounter, currentFrame, scene, {
						x: 3,
						y: 5
					});
					updateItems.itemRotation('Potato_3', hlCounter, currentFrame, scene, {
						x: 3,
						y: 2
					});
				}
			}
		});

		return scene;
	};

	// Вызов создания сцены
	const scene = createScene();

	// Запуск рендер цикла
	engine.runRenderLoop(function () {
		scene.render();
	});
});

const leftButton = createButton(`0px`, `auto`);
const rightButton = createButton(`auto`, `0px`);

closeButton.style.display = 'none';

// Функции для работы и переключения слайдера
$("[data-go-to-slide]").click(function () {
	let id = $(this).attr('data-go-to-slide');

	document.querySelectorAll(`.step1-link`).forEach((item) => {
		item.style.pointerEvents = `none`;
	});

	if (id == 1) {
		isItemsRotate = false; // нажатие креон
		hideSlides();

		animationSelected = 1;

		//прячем таблетку при нажатии на капсулу

		// const PILL_NODES = [`Object001`, `Cylinder258`];

		// PILL_NODES.forEach((item) => {
		// 	globalScene.getMeshByName(item).isVisible = false;
		// 	globalHighlight.addExcludedMesh(globalScene.getMeshByName(item));
		// });

		//Прячем капсулу при нажатии на таблетку
		// const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

		// KREON_NODES.forEach((item) => {
		// 	globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
		// 		item.isVisible = true;
		// 	});
		// });

		showKreon();

		globalScene.executeWhenReady(() => {
			Timer.returnToFrame(100 + START_FRAME);
			animationProperties.play();
			Timer.play();
		});

		isStartButtonPressed = true;
		isCloseButtonPressed = false;
		allowTimer = true;

		if (isMobileSize) {
			sliderContainer.appendChild(leftButton);
			sliderContainer.appendChild(rightButton);
			closeButton.style.display = 'block';
		}

		// Timer.play();

	} else if (id == 8) { //нажатие таблетки
		isItemsRotate = false;
		hideSlides();

		animationSelected = 0;

		// // Источники сноски
		// document.querySelector(`.kreon-source`).style.display = `none`;
		// document.querySelector(`.pill-source`).style.display = `block`;

		// //Прячем капсулу при нажатии на таблетку
		// const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

		// KREON_NODES.forEach((item) => {
		// 	globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
		// 		item.isVisible = false;
		// 	});
		// });

		// const PILL_NODES = [`Object001`, `Cylinder258`];

		// PILL_NODES.forEach((item) => {
		// 	globalScene.getMeshByName(item).isVisible = true;
		// });

		showPill();

		globalScene.executeWhenReady(() => {
			animationProperties.play();
			Timer.play();
		});

		isStartButtonPressed = true;
		isCloseButtonPressed = false;
		allowTimer = true;

		if (isMobileSize) {
			sliderContainer.appendChild(leftButton);
			sliderContainer.appendChild(rightButton);
			closeButton.style.display = 'block';
			callbackProperties.data[0].doneAt = START_FRAME;
		}
	} else if (id == 15) {
		isItemsRotate = false;
		hideSlides();

		animationSelected = 2;

		// // Источники сноски
		// document.querySelector(`.kreon-source`).style.display = `none`;
		// document.querySelector(`.pill-source`).style.display = `block`;

		// //Прячем капсулу при нажатии на таблетку
		// const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

		// KREON_NODES.forEach((item) => {
		// 	globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
		// 		item.isVisible = false;
		// 	});
		// });

		// const PILL_NODES = [`Object001`, `Cylinder258`];

		// PILL_NODES.forEach((item) => {
		// 	globalScene.getMeshByName(item).isVisible = true;
		// });

		showCapsule();

		globalScene.executeWhenReady(() => {
			Timer.returnToFrame(200 + START_FRAME);
			animationProperties.play();
			Timer.play();
		});

		isStartButtonPressed = true;
		isCloseButtonPressed = false;
		allowTimer = true;

		if (isMobileSize) {
			sliderContainer.appendChild(leftButton);
			sliderContainer.appendChild(rightButton);
			closeButton.style.display = 'block';
		}
	} else {
		hideSlides();
		animationProperties.play();
	}

	if (isMobileSize) {
		// Нажатие на паузу
		render.addEventListener('touchstart', (evt) => {
			evt.preventDefault();

			console.log('tost')

			if (allowTimer) {
				Timer.pause();
				animationProperties.pause();
			};
		});

		// Нажатие на воспроизведение
		render.addEventListener('touchend', (evt) => {
			evt.preventDefault();

			console.log('tost')

			if (allowTimer) {
				Timer.play();
				animationProperties.play();
			};
		});
	}
});

function openSlide(id) {
	$("[data-slider] .slider-item").eq(id).addClass('active');

	if ($("[data-slider] .slider-item.active").hasClass('last')) {
		$(".kreon ").addClass('last')
	} else {
		$(".kreon ").removeClass('last')
	}
}

function hideSlides() {
	$("[data-slider] .slider-item").removeClass('active');
}

$('.step3 .arrows-button').click(() => {
	// setTimeout(() => {
	// 	$('.step3 .arrows').removeClass('js-showed')
	// }, 1000)
	Timer.play();
});

$('.step6 .arrows-button').click(() => {
	animationProperties.play();
	Timer.play();
	hideSlides();
	// setTimeout(() => {
	// 	$('.step6 .arrows').removeClass('js-showed')
	// }, 1000);

	document.querySelectorAll(`.step6 .arrows-icon-item-circle`).forEach(item => {
		item.style.pointerEvents = `none`;
	});
	document.querySelectorAll(`.step6 .backto-button`).forEach(item => {
		item.style.pointerEvents = `none`;
	});
});

// Нажатие на кнопку повтора анимации
document.querySelectorAll('.step7-btn.newly').forEach((item) => {
item.addEventListener('click', (evt) => {
	const scrollRemove = selector => {
		console.log(selector);
		console.log({item: document.querySelector(selector)})

		if (document.querySelector(selector).classList.contains('scroll')) {
			console.log(`${selector} deleted`)

			document.querySelector(selector).classList.remove('scroll');
		}
	};

	evt.preventDefault();

	document.querySelectorAll('.step7-btn.newly').forEach((item) => {
		item.style.pointerEvents = `none`;
		item.style.cursor = `none`;
	});
	allowPlay = true;

	document.querySelector('.step2-microsphere-icon').classList.remove(`step2-microsphere-icon-show`);

	document.querySelector('.kreon-capsule .step7-link').style.pointerEvents = 'none';
	// document.querySelector('.another-pill .step7-link').style.pointerEvents = 'none';

	document.querySelector('.kreon-capsule .step7-btn.pills').style.pointerEvents = 'none';
	document.querySelector('.another-capsule .step7-btn.pills').style.pointerEvents = 'none';
	document.querySelector('.another-pill .step7-btn.pills').style.pointerEvents = 'none';

	// document.querySelectorAll(`.step1-link`).forEach((item) => {
	// 	item.style.pointerEvents = `all`;
	// });

	hideSlides();

	// animationProperties.returnToFrame(START_FRAME);
	// Timer.returnToFrame(START_FRAME);

	callbackProperties.resetAllFlags();

	let curFrame = Timer.getFrame();

	console.log(curFrame);

	animationProperties.returnToFrame(START_FRAME, false);
	callbackProperties.data[0].doneAt = START_FRAME;

	switch (true) {
		case curFrame < 100:
			Timer.returnToFrame(START_FRAME);

			break;
		case curFrame > 100 && curFrame < 200:
			Timer.returnToFrame(100.15);
			break;
		case curFrame > 200:
			Timer.returnToFrame(200.15);
			break;
	}

	animationProperties.play();
	Timer.play();

	globalScene.executeWhenReady(() => {
		if (document.querySelector('.slider-item.slide00').classList.contains('active')) {
			document.querySelector('.slider-item.slide00').classList.remove('active');
		}

		// animationProperties.pause();
		// animationProperties.returnToFrame(START_FRAME);
		// Timer.pause();
		// Timer.returnToFrame(START_FRAME);

		if (isMobileSize) {
			filterGradient.style.display = 'block';
			repeatButtonMobile.style.display = 'none';
			document.querySelector('.slider').style.pointerEvents = 'none';
			// document.querySelector('.kreon-capsule.step7').classList.remove('scroll');
			scrollRemove('.kreon-capsule.step7');
			// scrollRemove('.another-capsule.step7');
			document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'none';
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'none';
			startPillButtonMobile.style.pointerEvents = 'none';
			startPillButtonMobile.style.display = 'none';
			startKreonButtonMobile.style.pointerEvents = 'none';
			startKreonButtonMobile.style.display = 'none';
			if (document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
				document.querySelector('.slider-footer').classList.remove('at-last-slide');
			}
		}

		console.log(filterGradient.style.display)
	});

	// openSlide(0);
	updateItems.getItemsArray('stomachOff')[0].isEnabled = true;
	updateItems.getItemsArray('stomachOff2')[0].isEnabled = true;
	// isItemsRotate = true;

	// Исправление размера canvas для мобилки
	// render.classList.remove('render-mobile');

	if (isMobileSize) {
		clearTimeline();
		// sliderContainer.removeChild(leftButton);
		// sliderContainer.removeChild(rightButton);
		// closeButton.style.display = 'none';
	}

	// isCloseButtonPressed = true;
	allowTimer = true;

	// showKreon();
});
});

$('.kreon .slider .backto-button').click(event => {
	let parent = event.target.parentElement;
	switch (true) {
		case $(parent).hasClass('step6'):
			// hideSlides();
			// $('.slider .js-showed').removeClass('js-showed');

			if ($(parent).hasClass('kreon-capsule')) {
				Timer.returnToFrame(108.5);
				animationProperties.returnToFrame(8.5);
			} else if ($(parent).hasClass('another-pill')) {
				globalScene.executeWhenReady(() => {
					Timer.returnToFrame(11.1);
					animationProperties.returnToFrame(6);
				})
			} else if ($(parent).hasClass('another-capsule')) {
				globalScene.executeWhenReady(() => {
					Timer.returnToFrame(219);
					animationProperties.returnToFrame(10);
				})
			}
			updateItems.getItemsArray('stomachOff')[0].isEnabled = true;
			updateItems.getItemsArray('stomachOff2')[0].isEnabled = true;
			// setTimeout(() => {
			// 	animationProperties.play();
			// }, 0)
			// setTimeout(() => {
			// 	Timer.play();
			// }, 0);
			globalScene.executeWhenReady(() => {
				animationProperties.play();
				Timer.play();
			});
			break;
		default:
			hideSlides();
			animationProperties.play();
			animationProperties.returnToFrame(START_FRAME);
			break;
	}

	document.querySelectorAll(`.step6 .arrows-icon-item-circle`).forEach(item => {
		item.style.pointerEvents = `none`;
	});
	document.querySelectorAll(`.step6 .backto-button`).forEach(item => {
		item.style.pointerEvents = `none`;
	});

	console.log('pointer events ', document.querySelector(`.step6 .backto-button`).style.pointerEvents)

});

// $('.kreon-nav .test1').click(() => {
// 	animationProperties.pause()
// });
//
// $('.kreon-nav .test2').click(() => {
// 	animationProperties.play()
// });

$('.test-buttons .play').click(() => {
	animationProperties.play();
	Timer.play()
});

$('.test-buttons .pause').click(() => {
	animationProperties.pause();
	Timer.pause()
});

// Обработчик нажатия на кнопку закрыть в мобильной версии
const closeElementClickHandler = () => {
	const scrollRemove = selector => {
		console.log(selector);
		console.log({item: document.querySelector(selector)})

		if (document.querySelector(selector).classList.contains('scroll')) {
			console.log(`${selector} deleted`)

			document.querySelector(selector).classList.remove('scroll');
		}
	};

	allowTimer = false;
	hideSlides();
	globalScene.executeWhenReady(() => {
		animationProperties.returnToFrame(START_FRAME);
		animationProperties.play();
		Timer.returnToFrame(START_FRAME);
		Timer.play();

		if (isMobileSize) {
			filterGradient.style.display = 'block';
			repeatButtonMobile.style.display = 'none';
			document.querySelector('.slider').style.pointerEvents = 'none';
			document.querySelector('.mobile-buttons .step7-btn.newly').style.pointerEvents = 'none';
			document.querySelector('.mobile-buttons .step7-link').style.pointerEvents = 'none';
			startPillButtonMobile.style.pointerEvents = 'none';
			startPillButtonMobile.style.display = 'none';
			startKreonButtonMobile.style.pointerEvents = 'none';
			startKreonButtonMobile.style.display = 'none';
			// document.querySelector('.kreon-capsule.step7').classList.remove('scroll');
			scrollRemove('.kreon-capsule.step7');
			// scrollRemove('.another-capsule.step7');

			if (document.querySelector('.slider-footer').classList.contains('at-last-slide')) {
				document.querySelector('.slider-footer').classList.remove('at-last-slide');
			}
		}
		console.log(filterGradient.style.display)
	});
	openSlide(0);
	updateItems.getItemsArray('stomachOff')[0].isEnabled = true;
	updateItems.getItemsArray('stomachOff2')[0].isEnabled = true;
	callbackProperties.resetAllFlags();
	isItemsRotate = true;

	document.querySelector('.step2-microsphere-icon').classList.remove(`step2-microsphere-icon-show`);

	// Исправление размера canvas для мобилки
	// render.classList.remove('render-mobile');
	if ( render.classList.contains('render-mobile') ) {
		render.classList.remove('render-mobile');
	}
	clearTimeline();

	const PILL_NODES = [`Object001`, `Cylinder258`];

	PILL_NODES.forEach((item) => {
		globalScene.getMeshByName(item).isVisible = false;
	});

	const PILL_FERMENTS = [`Pill_Ferment_Pot3`, `Pill_Ferment_Pot2`, `Pill_Ferment_Chiken`, `Pill_Ferment_Chiken_Free`];

	PILL_FERMENTS.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	const KREON_NODES = [`Kapsula`, `MinimicrocapsulaFree`, `Minimicrocapsula`];

	KREON_NODES.forEach((item) => {
		globalScene.getNodeByName(item).getChildMeshes().forEach((item) => {
			item.isVisible = false;
		});
	});

	document.querySelectorAll(`.step1-link`).forEach((item) => {
		item.style.pointerEvents = `all`;
	});

	if (isMobileSize) {
		sliderContainer.removeChild(leftButton);
		sliderContainer.removeChild(rightButton);
		closeButton.style.display = 'none';
	}

	isStartButtonPressed = false;
	isCloseButtonPressed = true;
};

// document.querySelector('.another-pill .step7-btn.newly').addEventListener('click', closeElementClickHandler);
// document.querySelector('.kreon-capsule .step7-btn.newly').addEventListener('click', closeElementClickHandler);
// document.querySelector('.another-capsule .step7-btn.newly').addEventListener('click', closeElementClickHandler);
closeButton.addEventListener('click', closeElementClickHandler);

document.querySelector('.kreon-capsule .step7-btn.pills').addEventListener('click', () => {
	document.querySelector('.kreon-capsule .step7-link').style.pointerEvents = 'none';
	document.querySelector('.kreon-capsule .step7-btn.pills').style.pointerEvents = 'none';
	document.querySelectorAll('.kreon-capsule .step7-btn.newly').forEach((item) => {
		item.style.pointerEvents = `none`;
		item.style.cursor = `none`;
	});
	// document.querySelector('.another-pill .step7-link').style.pointerEvents = 'none';
	allowPlay = true;
	animationSelected = 0;
	showPill();
	// callbackProperties.resetAllFlags();
	Timer.returnToFrame(START_FRAME);
	animationProperties.returnToFrame(START_FRAME, false);
	callbackProperties.data[0].doneAt = START_FRAME;

	globalScene.executeWhenReady(() => {
		Timer.play();
		animationProperties.play();
	});
});

document.querySelector('.another-pill .step7-btn.pills').addEventListener('click', () => {
	document.querySelector('.another-pill .step7-btn.pills').style.pointerEvents = 'none';
	document.querySelectorAll('.another-pill .step7-btn.newly').forEach((item) => {
		item.style.pointerEvents = `none`;
		item.style.cursor = `none`;
	});
	// document.querySelector('.another-pill .step7-link').style.pointerEvents = 'none';

	allowPlay = true;
	animationSelected = 1;
	showKreon();
	// callbackProperties.resetAllFlags();
	Timer.returnToFrame(100 + START_FRAME);
	animationProperties.returnToFrame(START_FRAME);
	callbackProperties.resetAllFlags();
	allowPlay = true;

	globalScene.executeWhenReady(() => {
		Timer.play();
		animationProperties.play();
	});
});

document.querySelector('.another-capsule .step7-btn.pills').addEventListener('click', () => {
	document.querySelector('.another-capsule .step7-btn.pills').style.pointerEvents = 'none';
	document.querySelectorAll('.another-capsule .step7-btn.newly').forEach((item) => {
		item.style.pointerEvents = `none`;
		item.style.cursor = `none`;
	});

	allowPlay = true;
	animationSelected = 1;
	showKreon();
	// callbackProperties.resetAllFlags();
	Timer.returnToFrame(100 + START_FRAME);
	animationProperties.returnToFrame(START_FRAME);
	callbackProperties.resetAllFlags();

	globalScene.executeWhenReady(() => {
		Timer.play();
		animationProperties.play();
	});
});

// window.addEventListener("focus", function (event) {
// 	if (Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end && !isMobileSize && !isFocused && !globalEngine._windowIsBackground) {
// 		console.log(Timer.getFrame(), ' focused')
// 			Timer.play();
// 			if (allowPlay) {
// 				animationProperties.play();
// 				console.log('play')
// 			}
// 			isFocused = true;
// 	}
//
// }, false);

const minimizeController = {
	data: {
		isHidden: false,
		isDone: false
	},
	getVisibility: function () {
		return this.data.isHidden;
	},
	setVisibility: function(value = null) {
		this.data.isHidden = value != null ? value : isTabHidden;
	},
	getFlag: function () {
		return this.data.isDone;
	},
	setFlag: function(value = false) {
		this.data.isDone = value;
	},
	pause: function() {
		Timer.pause();
		animationProperties.pause();
		console.log('pause from minimize')
	},
	play: function() {
		setTimeout(() => {
			Timer.play();
			if (allowPlay) {
				animationProperties.play();
			}
			console.log('play from minimize');
		}, 50);
	},
	updateVisibility: function (frame) {
		if (!this.getFlag() && frame > intervals[animationSelected].start && frame < intervals[animationSelected].end) {
			switch (this.getVisibility()) {
				case true:
					this.pause();
					break;
				case false:
					this.play();
					break;
			}

			this.setFlag(true);

			setTimeout(() => {
				minimizeController.setFlag(false);
			}, 50);

			console.log(Timer.getFrame(), ' new method test');
			console.log(this, ' new method test');
		}
	}
};

// window.addEventListener(tabVisibility().visibilityChange, () => {
window.addEventListener(tabVisibility().visibilityChange, () => {
	// if (!tabVisibility().isVisible() && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end) {
	// 	Timer.play();
	// 	if (allowPlay) {
	// 		animationProperties.play();
	// 		console.log('play')
	// 	}
	// 	console.log(tabVisibility().isHidden(), ' focus')
	// } else
	// if (tabVisibility().isVisible() && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end) {
	// 	Timer.pause();
	// 	animationProperties.pause();
	// 	console.log(tabVisibility().isHidden(), ' blur')
	// }

	// switch (true) {
	// 	case tabVisibility().isVisible() == 'visible' && isFocused && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end:
	// 		Timer.play();
	// 		if (allowPlay) {
	// 			animationProperties.play();
	// 			console.log('play')
	// 		}
	// 		isFocused = false;
	// 		console.log(tabVisibility().isVisible(), ' focus');
	// 		break;
	// 	case tabVisibility().isVisible() == 'hidden' && !isFocused && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end:
	// 		Timer.pause();
	// 		animationProperties.pause();
	// 		setTimeout(() => {
	// 			isFocused = true;
	// 		});
	// 		console.log(tabVisibility().isVisible(), ' blur');
	// 		break;
	// 	default:
	// 		break;
	// }
	let visibility = tabVisibility().isHidden();

	isTabHidden = visibility;
	// isTabHidden = !isTabHidden;
	// console.log(isTabHidden, ' event check ', Timer.getFrame())
	// console.log(minimizeController.getVisibility(), ' event check 2 ', Timer.getFrame())

	// minimizeController.setVisibility(visibility);
	// minimizeController.updateVisibility(Timer.getFrame());

	// if (!foodPauseFrame.allowWrite && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end) {
	// 	console.log(foodPauseFrame, ' allowPlay');
	//
	// 	animationProperties.returnToFrame(foodPauseFrame.frame);
	// }
}, false);


// bind blur event
// window.addEventListener("blur", function (event) {
// 	if (Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end && !isMobileSize && isFocused) {
// 		console.log(Timer.getFrame(), ' blur')
// 		Timer.pause();
// 		animationProperties.pause();
// 		setTimeout(() => {
// 			isFocused = false;
// 		}, 50);
// 	}
// }, false);

// setInterval(() => {
// 	// console.log(tabVisibility().isHidden(), ' setinterval isHidden')
// 	// console.log(tabVisibility().isVisible(), ' setinterval isVisible')
//
// 	// switch (true) {
// 	// 	case tabVisibility().isVisible() == 'visible' && !isFocused && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end:
// 	// 		Timer.play();
// 	// 		if (allowPlay) {
// 	// 			animationProperties.play();
// 	// 			console.log('play');
// 	// 		}
// 	// 		isFocused = true;
// 	// 		console.log(tabVisibility().isVisible(), ' focus');
// 	// 		break;
// 	// 	case tabVisibility().isVisible() == 'hidden' && isFocused && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end:
// 	// 		Timer.pause();
// 	// 		animationProperties.pause();
// 	// 		isFocused = false;
// 	// 		console.log(tabVisibility().isVisible(), ' blur');
// 	// 		break;
// 	// 	default:
// 	// 		break;
// 	// }
//
// 	if (!tabVisibility().isHidden() && !isFocused && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end) {
// 		Timer.play();
// 		if (allowPlay) {
// 			animationProperties.play();
// 			console.log('play');
// 		}
// 		isFocused = true;
// 		console.log(tabVisibility().isVisible(), ' focus');
// 	} else if (tabVisibility().isHidden() && isFocused && Timer.getFrame() > intervals[animationSelected].start && Timer.getFrame() < intervals[animationSelected].end) {
// 		Timer.pause();
// 		animationProperties.pause();
// 		isFocused = false;
// 		console.log(tabVisibility().isVisible(), ' blur');
// 	}
// }, 50);

// do {
// 	// globalEngine._renderLoop();
// 	// globalScene.render();
//
// 	// updateItems.updateVisibility(Timer.getFrame(), globalScene);
// 	// callbackProperties.runEvent(Timer.getFrame());
// } while (tabVisibility().isHidden() && globalEngine != undefined)

// Удаление тегов br для слайда на мобильной версии
if (isMobileSize) {
	const mobileTextWrapping = document.querySelectorAll('.step3-info .step3-item br');

	mobileTextWrapping.forEach((item) => {
		item.remove();
	});
}
